  <template>
  <div class="khgl-container">
    <el-row class="tcf-row">
      <el-col  class="card">
        <div class="card-body">
          <div class="card-title">
            <el-tabs v-model="activeName" @tab-click="handleClick">
              <el-tab-pane label="所有客户" name="first"></el-tab-pane>
              <el-tab-pane label="新增客户" name="second"></el-tab-pane>
              <el-tab-pane label="意向客户" name="fourth"></el-tab-pane>
              <el-tab-pane label="已签客户" name="third"></el-tab-pane>
              <el-tab-pane name="five">
                <el-badge :value="waitPayNum" :hidden="waitPayNum<=0" :max="99" class="client-tab-badge" slot="label">待打款</el-badge>
              </el-tab-pane>
            </el-tabs>
            <div class="search-mode">
              <input type="text" class="search-input" @keyup.enter="Search" placeholder="关键字搜索" v-model="search" />
              <el-button class="search-btn" icon="el-icon-search" @click="Search"/>
              <el-button class="plus-btn"  type="primary" size="mini" icon="el-icon-plus" @click="editInfo(null)">新增客户</el-button>
            </div>
          </div>
          <div class="card-content" v-loading="loading">
            <div style="width: 100%;text-align: center;padding: 50px 0;" v-if="!loading&&total<=0">
              <i class="el-icon-document-copy" style="font-size: 5rem;color:rgb(203, 226, 252);"></i>
              <p style="color: #909399">暂无客户数据</p>
            </div>
            <div class="client-list" v-if="total>0">
              <div class="client-item" v-for="c in tableData" @click="openDetails(c)">
                <div class="name">
                  <span>{{c.name}}</span>
                  <svg-icon icon-class="client_man" class="client-sex" v-if="c.sex === 1"/>
                  <svg-icon icon-class="client_women" class="client-sex" v-if="c.sex === 0" />
                  <el-dropdown class="mark">
                    <span class="el-dropdown-link"><i class="el-icon-more"></i></span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item @click.native="editInfo(c)" :disabled="c.mark>=3"><i class="el-icon-edit-outline"></i> 编辑</el-dropdown-item>
                      <el-dropdown-item @click.native="delClient(c)" :disabled="c.mark>=3 || c.groupid==4"><i class="el-icon-delete"></i> 删除</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
                <div class="info-box">
                  <div class="label"><i class="el-icon-medal"></i> 客户等级</div>
                  <div class="txt" style="padding-top: 8px"><el-rate v-model="c.level" disabled-void-color="#ffffff" disabled></el-rate></div>
                </div>
                <div class="info-box">
                  <div class="label"><i class="el-icon-mobile-phone"></i> 联系电话</div>
                  <div class="txt">{{c.tel}}</div>
                </div>
                <div class="info-box">
                  <div class="label"><i class="el-icon-map-location"></i> 所在地区</div>
                  <div class="txt">{{c.province}} {{c.city}} {{c.county}}</div>
                </div>
                <div class="info-box">
                  <div class="label"><i class="el-icon-document"></i> 客户状态</div>
                  <div class="txt" v-if="c.refund!==1">
                    <el-tag type="danger" :disable-transitions="true" size="mini" v-if="c.is_recycle==1 && c.mark<3">即将回收</el-tag>
                    <el-tag type="warning" :disable-transitions="true" size="mini" v-if="c.is_recycle!=1 && c.mark<3 && c.groupid!=4">待跟进</el-tag>
                    <el-tag type="success" :disable-transitions="true" size="mini" v-if="c.is_recycle!=1 && c.mark<3 && c.groupid==4">已转意向</el-tag>
                    <el-tag size="mini" :disable-transitions="true" v-if="c.mark===3&&c.paymark===10" class="tcf-tag-8">待打款</el-tag>
                    <el-tag size="mini" :disable-transitions="true" v-if="c.mark===3&&(c.paymark===0||c.paymark===1)" class="tcf-tag-4">收款审核中</el-tag>
                    <el-tag size="mini" :disable-transitions="true" v-if="c.mark===3&&(c.paymark===3||c.paymark===4)" type="danger">收款审核拒绝</el-tag>
                    <el-tag size="mini" :disable-transitions="true" v-if="c.mark===9">已完成</el-tag>
                  </div>
                  <div class="txt" v-if="c.refund===1">
                    <el-tag size="mini" :disable-transitions="true" type="info" v-if="c.refund===1">已退款</el-tag>
                  </div>
                </div>
                <div class="info-box">
                  <div class="label"><i class="el-icon-timer"></i> 上次跟进</div>
                  <div class="txt" :style="c.is_recycle==1&&c.mark<3?'color:#F56C6C':''">{{c.followtime}}</div>
                </div>
              </div>
            </div>
            <el-pagination
              v-if="total>0"
              background
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[10, 20, 50]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total">
            </el-pagination>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      :title="editTitle"
      :visible.sync="editInfoVisible"
      width="40%"
      top="10vh"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true">
      <el-form ref="eForm" :model="eForm" :rules="eRules"  label-position="right" label-width="75px" size="small">
        <el-form-item label="姓名" prop="name">
          <el-input v-model="eForm.name" maxlength="5" placeholder="请输入客户姓名"></el-input>
        </el-form-item>
        <el-form-item label="电话" prop="tel">
          <el-input v-model="eForm.tel" :disabled="eForm.cid!=0" maxlength="11" placeholder="请输入11位手机号码" minlength="11"></el-input>
        </el-form-item>
        <el-form-item label="微信" prop="wchat">
          <el-input v-model="eForm.wchat" maxlength="20" placeholder="请输入客户微信号"></el-input>
        </el-form-item>
        <el-form-item label="性别" prop="sex">
          <el-radio-group v-model="eForm.sex">
            <el-radio :label="2">未知</el-radio>
            <el-radio :label="1">男</el-radio>
            <el-radio :label="0">女</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="地区" prop="city">
          <el-cascader
            style="width:100%"
            v-model="eForm.city"
            :options="cityoptions"
            placeholder="请选择客户所在地区"
            filterable></el-cascader>
        </el-form-item>
        <el-form-item label="客户等级" prop="level">
          <el-rate v-model="eForm.level" style="padding-top: 6px"></el-rate>
        </el-form-item>
        <el-form-item label="线下门店" prop="shop">
          <el-input v-model="eForm.shop" maxlength="100" placeholder="请输入线下门店地址"></el-input>
        </el-form-item>
        <el-form-item label="门店面积" prop="area" style="width: 300px;">
          <el-input v-model="eForm.area" type="number" placeholder="请输入门店面积">
            <template slot="append">m²</template>
          </el-input>
        </el-form-item>
        <el-form-item label="客户来源" prop="source">
          <el-select v-model="eForm.source" placeholder="请选择客户来源">
            <el-option label="第三方平台" :value="1"></el-option>
            <el-option label="招商会" :value="2"></el-option>
            <el-option label="异业介绍" :value="3"></el-option>
            <el-option label="地推" :value="4"></el-option>
            <el-option label="商场推荐" :value="5"></el-option>
            <el-option label="数字名片" :value="6"></el-option>
            <el-option label="其他" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input type="textarea" v-model="eForm.remark" maxlength="200" placeholder="请输入备注内容"></el-input>
        </el-form-item>
        <el-form-item style="text-align: right;">
          <el-button type="primary" :loading="editloading" @click="submitForm('eForm')">立即提交</el-button>
          <el-button @click="editInfoVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      title="编辑跟进记录"
      :visible.sync="editRecordVisible"
      width="40%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true">
      <el-form ref="recordForm" :model="recordForm" :rules="rulesRecord"  label-position="right" label-width="75px" size="small">
        <el-form-item label="方式" prop="way" >
          <el-select v-model="recordForm.way">
            <el-option
              v-for="witem in wayOption"
              :label="witem.name"
              :value="witem.name">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="内容" prop="content">
          <el-input type="textarea" placeholder="输入跟进内容" v-model="recordForm.content" maxlength="300"></el-input>
        </el-form-item>
        <el-form-item label="图片" prop="imgids">
          <MultiImg :key="recordForm.key" :limit="99" v-model="recordForm.imgids" :old="recordForm.oldImages" :size="'sm'" />
        </el-form-item>
        <el-form-item style="text-align: right;">
          <el-button type="primary" :loading="editFollowLoading2" @click="subEditRecord('recordForm')">提交</el-button>
          <el-button @click="editRecordVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      :visible.sync="viewVisible"
      title="客户档案"
      width="70%"
      top="10vh"
      :destroy-on-close="true"
      :lock-scroll="true"
      custom-class="khgl-client-detail"
      :append-to-body="true">
      <div class="view-box" v-loading="viewLoading">
        <el-steps :active="clientDetail.mark===2&&clientDetail.groupid===4?2:clientDetail.mark===3?3:clientDetail.mark===9?4:1" simple>
          <el-step title="客户录入" icon="el-icon-edit-outline"></el-step>
          <el-step title="转意向" icon="el-icon-refresh"></el-step>
          <el-step title="合同签订" icon="el-icon-document-checked"></el-step>
          <el-step title="打款" icon="el-icon-coin"></el-step>
          <el-step title="建店" icon="el-icon-office-building"></el-step>
        </el-steps>
        <el-row style="margin-top: 20px">
          <el-col :span="8">
            <el-card class="base-info" shadow="never">
              <div slot="header" class="tit">
                <span>基本资料</span>
                <el-dropdown v-if="clientDetail.mark<3" split-button size="small" @click="editInfo(clientDetail)" class="client-info-dropdown">
                  <i class="el-icon-edit-outline"></i> 编辑
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item @click.native="delClient(clientDetail)" :disabled="(clientDetail.mark>=3 || clientDetail.groupid==4)&&clientDetail.refund!==1"><i class="el-icon-delete"></i> 删除</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
              <div class="text">
                <div class="l">
                  <span class="label">客户姓名:</span>
                  <span class="name">{{clientDetail.name}}</span>
                  <svg-icon icon-class="client_man" class="client-sex" v-if="clientDetail.sex === 1"/>
                  <svg-icon icon-class="client_women" class="client-sex" v-if="clientDetail.sex === 0" />
                </div>
                <div class="l">
                  <span style="float: left" class="label">客户等级:</span>
                  <el-rate style="float: left" v-model="clientDetail.level" disabled-void-color="#ffffff" disabled></el-rate>
                </div>
                <div class="l">
                  <span style="float: left" class="label">联系电话:</span>
                  <span>{{clientDetail.tel}}</span>
                </div>
                <div class="l">
                  <span style="float: left" class="label">客户微信:</span>
                  <span>{{clientDetail.wchat!==null&&clientDetail.wchat!==undefined&&clientDetail.wchat!==''?clientDetail.wchat:'N/A'}}</span>
                </div>
                <div class="l">
                  <span style="float: left" class="label">所在地区:</span>
                  <span>{{clientDetail.province}} {{clientDetail.city}} {{clientDetail.county}}</span>
                </div>
                <el-alert v-if="clientDetail.areadealerlst.length<=0&&clientDetail.mark===2" title="该区域目前还未有代理经销商" type="success" :closable="false" style="margin-bottom: 15px" show-icon></el-alert>
                <el-popover
                  v-if="clientDetail.areadealerlst.length>0"
                  placement="right"
                  width="420"
                  :key="areaKey"
                  trigger="hover">
                  <el-table :data="clientDetail.areadealerlst">
                    <el-table-column width="120" property="allname" label="经销商" show-overflow-tooltip></el-table-column>
                    <el-table-column width="100" label="代理品牌" show-overflow-tooltip>
                      <template slot-scope="scope">
                        <span v-for="(b,index) in scope.row.brandlst">{{b.brandname}}{{index===scope.row.brandlst.length-1?'':'、'}}</span>
                      </template>
                    </el-table-column>
                    <el-table-column min-width="100" label="所在地区" show-overflow-tooltip>
                      <template slot-scope="scope">
                        {{scope.row.province}} {{scope.row.city}} {{scope.row.county}}
                      </template>
                    </el-table-column>
                  </el-table>
                  <el-alert slot="reference" :title="`该区域目前已有${clientDetail.areadealerlst.length}个代理经销商`" type="warning" :closable="false" style="margin-bottom: 15px;cursor: pointer" show-icon></el-alert>
                </el-popover>
                <div class="l">
                  <span style="float: left" class="label">线下门店:</span>
                  <span>{{clientDetail.shop!==null&&clientDetail.shop!==undefined&&clientDetail.shop!==''?clientDetail.shop:'N/A'}}</span>
                </div>
                <div class="l">
                  <span style="float: left" class="label">门店面积:</span>
                  <span>{{clientDetail.area!==null&&clientDetail.area!==undefined&&clientDetail.area!==''&&clientDetail.area>0?clientDetail.area+' m²':'N/A'}}</span>
                </div>
                <div class="l">
                  <span style="float: left" class="label">客户来源:</span>
                  <span>{{clientDetail.source===1?'第三方平台':clientDetail.source===2?'招商会':clientDetail.source===3?'异业介绍':clientDetail.source===4?'地推':clientDetail.source===5?'商场推荐':clientDetail.source===6?'数字名片':'其他'}}</span>
                </div>
                <div class="l">
                  <span style="float: left" class="label">客户状态:</span>
                  <el-tag type="danger" :disable-transitions="true" size="mini" v-if="clientDetail.is_recycle==1 && clientDetail.mark<3 && clientDetail.refund!==1">即将回收</el-tag>
                  <el-tag type="warning" :disable-transitions="true" size="mini" v-if="clientDetail.is_recycle!=1 && clientDetail.mark<3 && clientDetail.groupid!=4 && clientDetail.refund!==1">待跟进</el-tag>
                  <el-tag type="success" :disable-transitions="true" size="mini" v-if="clientDetail.is_recycle!=1 && clientDetail.mark<3 && clientDetail.groupid==4 && clientDetail.refund!==1">已转意向</el-tag>
                  <el-tag size="mini" :disable-transitions="true" v-if="clientDetail.mark===3&&clientDetail.paymark===10 && clientDetail.refund!==1" class="tcf-tag-8">待打款</el-tag>
                  <el-tag size="mini" :disable-transitions="true" v-if="clientDetail.mark===3&&(clientDetail.paymark===0||clientDetail.paymark===1) && clientDetail.refund!==1" class="tcf-tag-4">收款审核中</el-tag>
                  <el-tag size="mini" :disable-transitions="true" v-if="clientDetail.mark===3&&(clientDetail.paymark===3||clientDetail.paymark===4) && clientDetail.refund!==1" type="danger">收款审核拒绝</el-tag>
                  <el-tag size="mini" :disable-transitions="true" v-if="clientDetail.mark===9 && clientDetail.refund!==1">已完成</el-tag>
                  <el-tag size="mini" :disable-transitions="true" type="info" v-if="clientDetail.refund===1">已退款</el-tag>
                </div>
                <div class="l">
                  <span style="float: left" class="label">客户备注:</span>
                  <span>{{clientDetail.remark!==null&&clientDetail.remark!==undefined&&clientDetail.remark!==''?clientDetail.remark:'N/A'}}</span>
                </div>
              </div>
            </el-card>
            <el-card shadow="never" class="principal" v-if="clientDetail.followname!==null&&clientDetail.followname!==undefined&&clientDetail.followname!==''">
              <div slot="header" class="tit">
                <span>负责人</span>
              </div>
              <el-row>
                <el-col :span="14" class="user-info" style="line-height: 36px">
                  <el-avatar size="medium" :src="clientDetail.followphoto" style="float: left;margin-right: 10px"></el-avatar>
                  <span>{{clientDetail.followname}}</span>
                </el-col>
                <el-col :span="10" style="text-align: right;line-height: 36px">
                  <el-dropdown trigger="click" v-if="clientDetail.mark===2" placement="top" :key="forwardKey">
                    <el-button size="mini">移交 <i class="el-icon-caret-top"></i></el-button>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item v-for="u in clientDetail.forwardlist" @click.native="forwardC(u)"><el-avatar :src="u.photourl" style="margin-right: 8px;width: 22px;height: 22px;line-height: 22px;float: left;margin-top: 7px"></el-avatar>{{u.dName}}</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </el-col>
              </el-row>
            </el-card>
          </el-col>
          <el-col :span="16" style="padding-left: 20px">
            <el-tabs v-model="activeViewName" :key="detailKey">
              <el-tab-pane label="跟进记录" name="gjjl"></el-tab-pane>
              <el-tab-pane label="转意向" name="yxj"></el-tab-pane>
              <el-tab-pane v-if="(clientDetail.mark===2 && clientDetail.groupid==4)||clientDetail.mark>=3" label="合同档案" name="htda"></el-tab-pane>
              <el-tab-pane v-if="clientDetail.mark===9" label="代理信息" name="dlxx"></el-tab-pane>
              <el-tab-pane v-if="clientDetail.mark===9" label="建店详情" name="jdxq"></el-tab-pane>
            </el-tabs>
            <div v-if="activeViewName === 'gjjl'">
              <div class="follow-from">
                <div class="btn-box">
                  <span style="color: #F56C6C">*</span>
                  <el-dropdown :key="wayKey" placement="bottom" trigger="click">
                    <span style="font-size: 13px;cursor: pointer">
                      {{ followFrom.way!==null&&followFrom.way!==undefined&&followFrom.way!==''?followFrom.way:'跟进方式' }}<i class="el-icon-caret-bottom"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item v-for="w in wayOption" @click.native="followFrom.way=w.name">{{w.name}}</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                  <div style="position: absolute;top: -2px;right: 15px; ">
                    <el-button size="mini" @click="intoHighSeas" :loading="changeIntentLoading" v-if="clientDetail.mark===2" type="danger">放入公海</el-button>
<!--                    <el-button size="mini" @click="changeIntent" :loading="changeIntentLoading" v-if="clientDetail.mark===2 && clientDetail.groupid!=4" type="success">转意向</el-button>-->
                    <el-button size="mini" @click="subFollowRecord" :loading="editFollowLoading" type="primary">提交跟进</el-button>
                  </div>
                </div>
                <el-input type="textarea" maxlength="300" placeholder="输入跟进内容" :resize="'none'" v-model="followFrom.content"></el-input>
                <div class="follow-img-box"><MultiImg :limit="99" :key="followImgKey" :size="'min'" ref="img" v-model="followFrom.imgids" /></div>
              </div>
              <div class="follow-list" v-loading="followLoading">
                <div class="follow-item" v-for="f in followList">
                  <div class="edit-btn" v-if="f.userid===user.dUserid&&f.type===1&&f.way!=='客户录入'">
                    <el-button size="mini" @click="editFollow(f)" type="text" icon="el-icon-edit-outline">编辑</el-button>
                  </div>
                  <div  class="follow-userinfo" v-if="f.username===null||f.username===undefined||f.username===''">
                    <el-avatar class="photo" shape="square" :size="50" :src="elichain_photo"></el-avatar>
                    <div class="name">慕鹿助手<el-tag size="mini" :type="f.type===0?'danger':f.way==='客户录入'?'':'warning'">{{f.way}}</el-tag></div>
                    <div class="time">{{f.time}}</div>
                  </div>
                  <div class="follow-userinfo" v-if="f.username!==null&&f.username!==undefined&&f.username!==''">
                    <el-avatar class="photo" shape="square" :size="50" :src="f.photourl"></el-avatar>
                    <div class="name">{{f.username}}<el-tag size="mini" :type="f.type===0?'danger':f.way==='客户录入'?'':'warning'">{{f.way}}</el-tag></div>
                    <div class="time">{{f.time}}</div>
                  </div>
                  <div class="follow-content" v-if="f.content!==null&&f.content!==undefined&&f.content!==''">{{f.content}}</div>
                  <div class="follow-imgs" v-if="f.imgurlarr.length>0">
                    <el-image
                      v-for="img in f.imgurlarr"
                      fit="cover"
                      class="follow-img"
                      :src="img"
                      :preview-src-list="f.imgurlarr"
                    />
                  </div>
                </div>
<!--                <div class="follow-item">-->
<!--                  <div class="follow-userinfo">-->
<!--                    <el-avatar class="photo" shape="square" :size="50" :src="clientDetail.createphoto"></el-avatar>-->
<!--                    <div class="name">{{clientDetail.createname}}<el-tag size="mini">客户录入</el-tag></div>-->
<!--                    <div class="time">{{clientDetail.createtime}}</div>-->
<!--                  </div>-->
<!--                  <div class="follow-content">-->
<!--                    由&nbsp;<span style="color: #409EFF">{{clientDetail.createdept}}-{{clientDetail.createname}}</span>&nbsp;录入此客户-->
<!--                  </div>-->
<!--                </div>-->
              </div>
            </div>
            <div v-if="activeViewName === 'yxj'">
              <el-card shadow="never" class="base-info" v-if="clientDetail.mark===2&&yxjForm.mark<9&&yxjForm.mark!==2">
                <div slot="header" class="tit">
                  <span>意向金确认单</span>
                </div>
                <el-form ref="yxjForm" :model="yxjForm" :rules="yxjRules" label-position="right" label-width="75px" size="small">
                  <el-alert
                    v-if="yxjForm.mark<2&&yxjForm.mark>=0"
                    title="意向金正在审核中，在此期间也可以重新编辑信息"
                    type="warning"
                    :closable="false"
                    style="margin-bottom: 20px"
                    show-icon>
                  </el-alert>
                  <el-alert
                    v-if="yxjForm.mark===3||yxjForm.mark===4"
                    title="审核拒绝"
                    :closable="false"
                    style="margin-bottom: 20px"
                    type="error">
                    <div style="color:#606266;font-size: 13px;margin-bottom: 5px">
                      <span><span style="color:#99a9bf">审核时间：</span>{{yxjForm.mark===3?clientDetail.clientInmon.dirtime:clientDetail.clientInmon.audittime}}</span>
                      <span style="margin-left: 30px;"><span style="color:#99a9bf">审核人：</span>{{yxjForm.mark===3?clientDetail.clientInmon.dirname:clientDetail.clientInmon.auditname}}</span>
                    </div>
                    <div style="color:#606266;font-size: 13px;" v-if="clientDetail.clientInmon.rson!=''&&clientDetail.clientInmon.rson!=null">
                      <span style="color:#99a9bf">拒绝原因：</span>{{clientDetail.clientInmon.rson}}
                    </div>
                  </el-alert>
                  <el-form-item label="加盟地区" prop="city">
                    <el-cascader
                      style="width:100%"
                      v-model="yxjForm.city"
                      :options="yxjcityoptions"
                      placeholder="请选择城市"
                      filterable></el-cascader>
                  </el-form-item>
                  <el-form-item label="加盟品牌" prop="bid">
                    <el-select v-model="yxjForm.bid" style="width:100%" placeholder="请选择">
                      <el-option
                        v-for="item in brandList"
                        :key="item.brand_id"
                        :label="item.brand_name"
                        :value="item.brand_id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="意向金" prop="money">
                    <el-input v-model="yxjForm.money" disabled oninput="value=value.replace(/[^0-9.]/g,'')" style="width: 200px"><template slot="append">元</template></el-input>
                  </el-form-item>
                  <template v-if="yxjForm.money>0">
                    <el-form-item label="打款卡号" prop="card">
                      <el-input v-model="yxjForm.card" maxlength="100" placeholder="请输入汇款人“卡号/尾号”，例如“张三/1234”" show-word-limit></el-input>
                    </el-form-item>
                    <el-form-item label="打款日期" prop="receipttime">
                      <el-date-picker
                        v-model="yxjForm.receipttime"
                        type="date"
                        style="width:240px"
                        format="yyyy年MM月dd日"
                        value-format="yyyy-MM-dd"
                        placeholder="选择日期">
                      </el-date-picker>
                    </el-form-item>
                    <el-form-item label="收款账户" prop="aid">
                      <el-select v-model="yxjForm.aid" style="width:100%" placeholder="请选择" clearable filterable>
                        <el-option-group
                          v-for="gitem in groupList"
                          v-if="gitem.nature===0"
                          :key="gitem.groupid"
                          :label="gitem.account_name">
                          <el-option
                            v-for="item in accountsList"
                            v-if="item.groupid===gitem.groupid"
                            :key="item.aid"
                            :label="item.name+'（'+item.card+'）'"
                            :value="item.aid">
                            <span style="float: left">{{ item.name }}</span>
                            <span style="float: right; color: #8492a6; font-size: 13px">{{ item.card }}</span>
                          </el-option>
                        </el-option-group>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="打款凭证" prop="yxjimgids">
                      <MultiImg :limit="9" :size="'sm'" :old="oldyxjeditimgList" :key="yxjpayImgKey" v-model="yxjForm.yxjimgids" />
                    </el-form-item>
                 </template>
                  <el-form-item label="享受权限" prop="remark">
                    <el-input type="textarea" v-model="yxjForm.enjoy"  show-word-limit></el-input>
                  </el-form-item>
                  <el-form-item label="备注" prop="remark">
                    <div style="font-size: 12px;color:#9aaabf" >
                      <i class=" el-icon-info"></i> 温馨提示：
                      <span>若已确定门店，请于下方"备注"栏写明门店地址及面积信息</span>
                    </div>
                    <el-input type="textarea" v-model="yxjForm.remark" maxlength="200" show-word-limit></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-button type="primary" :loading="zyxChangeLoading" @click="changeIntent('yxjForm')">立即提交</el-button>
                  </el-form-item>
                </el-form>
              </el-card>
              <el-card shadow="never" class="base-info" v-if="yxjForm.mark===2&&clientDetail.clientInmon!==null&&clientDetail.clientInmon!==undefined&&clientDetail.clientInmon!==''">
                <div slot="header" class="tit">
                  <span>意向金信息</span>
                </div>
                <div class="text" v-loading="yxjxxLoading">
                  <div class="l">
                    <span style="float: left" class="label">加盟地区:</span>
                    <span>{{clientDetail.clientInmon.province}} - {{clientDetail.clientInmon.city}}</span>
                  </div>
                  <div class="l">
                    <span style="float: left" class="label">意向品牌:</span>
                    <span><el-tag size="mini" :disable-transitions="true" style="margin-right: 10px" effect="plain">{{clientDetail.clientInmon.brandname}}</el-tag></span>
                  </div>
                  <div class="l">
                    <span style="float: left" class="label">意向金额:</span>
                    <span>{{clientDetail.clientInmon.money}}</span>
                  </div>
                  <template v-if="clientDetail.clientInmon.money>0">
                    <div class="l">
                      <span style="float: left" class="label">打款卡号:</span>
                      <span>{{clientDetail.clientInmon.card}}</span>
                    </div>
                    <div class="l">
                      <span style="float: left" class="label">打款日期:</span>
                      <span>{{clientDetail.clientInmon.receipttime}}</span>
                    </div>
                    <div class="l">
                      <span style="float: left" class="label">收款账户:</span>
                      <span>{{ clientDetail.clientInmon.accname }}（{{clientDetail.clientInmon.acccard}}）</span>
                    </div>
                  </template>
                  <div class="l">
                    <span style="float: left" class="label">享受权限:</span>
                    <span>{{clientDetail.clientInmon.enjoy!==null&&clientDetail.clientInmon.enjoy!==undefined&&clientDetail.clientInmon.enjoy!==''?clientDetail.clientInmon.enjoy:'N/A'}}</span>
                  </div>
                  <div class="l">
                    <span style="float: left" class="label">填写备注:</span>
                    <span>{{clientDetail.clientInmon.remark!==null&&clientDetail.clientInmon.remark!==undefined&&clientDetail.clientInmon.remark!==''?clientDetail.clientInmon.remark:'N/A'}}</span>
                  </div>
                  <div class="l">
                    <span style="float: left" class="label">打款凭证:</span>
                    <el-image v-for="iurl in yxjpayImgs"
                              style="width: 60px; height: 60px;margin-right: 10px;margin-bottom: 10px;border: 1px dashed #f5f7fa;"
                              :src="iurl"
                              :preview-src-list="yxjpayImgs">
                    </el-image>
                  </div>
                  <div class="l" style="align-content: center;" v-if="(clientDetail.yxjtk===null||clientDetail.yxjtk===undefined||clientDetail.yxjtk==='') && clientDetail.clientInmon.money!=0">
                    <el-button style="align-content: center" type="danger" size="small" @click="refundApply()">申请退款</el-button>
                  </div>
                </div>
              </el-card>
              <el-card shadow="never" style="margin-top: 20px" class="base-info" v-if="clientDetail.yxjtk!==null&&yxjForm.mark===2">
                <div slot="header" class="tit">
                  <span>意向金退款</span>
                  <div style="position: absolute;right: 0;top: 0"  v-if="clientDetail.yxjtk.mark!==2">
                    <el-button  style="align-content: center" type="primary" icon="el-icon-edit" size="mini" @click="refundApply()">编辑信息</el-button>
                  </div>
                </div>
                <el-alert
                  v-if="clientDetail.yxjtk.mark>=0&&clientDetail.yxjtk.mark<=1"
                  title="意向金退款正在审核中，在此期间也可以重新编辑退款信息"
                  type="warning"
                  :closable="false"
                  style="margin-bottom: 20px"
                  show-icon>
                </el-alert>
                <el-alert
                  v-if="(clientDetail.yxjtk.mark===3||clientDetail.yxjtk.mark===4)&&clientDetail.yxjtk.type===0"
                  title="退款审核拒绝"
                  :closable="false"
                  style="margin-bottom: 20px"
                  type="error">
                  <div style="color:#606266;font-size: 13px;margin-bottom: 5px">
                    <span><span style="color:#99a9bf">审核时间：</span>{{clientDetail.yxjtk.mark===3?clientDetail.yxjtk.dirtime:clientDetail.yxjtk.audittime}}</span>
                    <span style="margin-left: 30px;"><span style="color:#99a9bf">审核人：</span>{{clientDetail.yxjtk.mark===3?clientDetail.yxjtk.dirname:clientDetail.yxjtk.auditname}}</span>
                  </div>
                  <div style="color:#606266;font-size: 13px;" v-if="clientDetail.yxjtk.rson!=''&&clientDetail.yxjtk.rson!=null">
                    <span style="color:#99a9bf">拒绝原因：</span>{{clientDetail.yxjtk.rson}}
                  </div>
                </el-alert>
                <div class="text" v-loading="yxjtkxxLoading">
                  <div class="l">
                    <span style="float: left" class="label">收款人:</span>
                    <span>{{clientDetail.yxjtk.name}}</span>
                  </div>
                  <div class="l">
                    <span style="float: left" class="label">开户行:</span>
                    <span>{{clientDetail.yxjtk.bank}}</span>
                  </div>
                  <div class="l">
                    <span style="float: left" class="label">退款金额:</span>
                    <span>{{clientDetail.yxjtk.money}}</span>
                  </div>
                  <div class="l">
                    <span style="float: left" class="label">收款卡号:</span>
                    <span>{{clientDetail.yxjtk.card}}</span>
                  </div>
                  <div class="l">
                    <span style="float: left" class="label">退款原因:</span>
                    <span>{{clientDetail.yxjtk.refundrson!==null&&clientDetail.yxjtk.refundrson!==undefined&&clientDetail.yxjtk.refundrson!==''?clientDetail.yxjtk.refundrson:'N/A'}}</span>
                  </div>
                  <div class="l">
                    <span style="float: left" class="label">退款备注:</span>
                    <span>{{clientDetail.yxjtk.remark!==null&&clientDetail.yxjtk.remark!==undefined&&clientDetail.yxjtk.remark!==''?clientDetail.yxjtk.remark:'N/A'}}</span>
                  </div>
                </div>
              </el-card>
            </div>
            <div v-if="activeViewName === 'htda'">
              <el-card shadow="never" class="base-info" v-if="clientDetail.mark===2 && clientDetail.groupid==4">
                <div slot="header" class="tit">
                  <span>合同签订</span>
                </div>
                <el-form ref="htqdForm" :model="htqdForm" :rules="htqdRules" label-position="right" label-width="75px" size="small">
                  <el-form-item label="签订日期" prop="time">
                    <el-date-picker
                      v-model="htqdForm.time"
                      type="date"
                      style="width:240px"
                      format="yyyy年MM月dd日"
                      value-format="yyyy-MM-dd"
                      placeholder="选择日期">
                    </el-date-picker>
                  </el-form-item>
                  <el-form-item label="签订地点" prop="address">
                    <el-input v-model="htqdForm.address" maxlength="20" placeholder="请输入签订地点"></el-input>
                  </el-form-item>
                  <el-form-item label="签订合同" prop="contractid">
                    <el-select v-model="htqdForm.contractid" style="width:350px" placeholder="请选择" clearable filterable>
                      <el-option
                        v-for="item in contractList"
                        :key="item.cid"
                        :label="item.name+'（'+item.code+'）'"
                        :value="item.cid">
                        <span style="float: left">{{ item.name }}</span>
                        <span style="float: right; color: #8492a6; font-size: 13px">{{ item.code }}</span>
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="客户全称" prop="allname">
                    <el-col :span="6">
                      <el-input placeholder="地区" @input="setAllName" v-model="htqdForm.allnameArea"></el-input>
                    </el-col>
                    <el-col :span="1" style="text-align: center">-</el-col>
                    <el-col :span="6">
                      <el-input placeholder="姓名" @input="setAllName" v-model="htqdForm.allnameTxt"></el-input>
                    </el-col>
                  </el-form-item>
                  <el-form-item label="代理品牌" prop="brand">
                    <el-select v-model="htqdForm.brand" style="width:100%" multiple placeholder="请选择">
                      <el-option
                        v-for="item in brandList"
                        :key="item.brand_id"
                        :label="item.brand_name"
                        :value="item.brand_id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="展厅负责" prop="groupId">
                    <el-select v-model="htqdForm.groupId" placeholder="请选择">
                      <el-option
                        v-for="item in groupList"
                        v-if="item.nature===0"
                        :key="item.groupid"
                        :label="item.group_name"
                        :value="item.groupid">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="合同原件" prop="imgids">
                    <MultiImg :limit="99" :key="htqdImgKey" :size="'sm'" v-model="htqdForm.imgids" />
                  </el-form-item>
                  <el-form-item label="合同备注" prop="remark">
                    <el-input type="textarea" v-model="htqdForm.remark" maxlength="300"></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-button type="primary" :loading="htqdLoading" @click="subHtqd('htqdForm')">立即提交</el-button>
                  </el-form-item>
                </el-form>
              </el-card>
              <el-card shadow="never" class="base-info" v-if="clientDetail.mark===3" style="margin-bottom: 20px">
                <div slot="header" class="tit">
                  <span>样品预存款确认单</span>
                </div>
                <el-form ref="payForm" :model="payForm" :rules="payRules"  label-position="right" label-width="75px" size="small">
                  <el-alert
                    v-if="clientDetail.paymark===3||clientDetail.paymark===4"
                    title="收款审核拒绝"
                    :closable="false"
                    style="margin-bottom: 20px"
                    type="error">
                    <div style="color:#606266;font-size: 13px;margin-bottom: 5px">
                      <span><span style="color:#99a9bf">审核时间：</span>{{clientDetail.paymark===3?clientDetail.payinfo.dirtime:clientDetail.payinfo.audittime}}</span>
                      <span style="margin-left: 30px;"><span style="color:#99a9bf">审核人：</span>{{clientDetail.paymark===3?clientDetail.payinfo.dirname:clientDetail.payinfo.auditname}}</span>
                    </div>
                    <div style="color:#606266;font-size: 13px;" v-if="clientDetail.payinfo.rson!=''&&clientDetail.payinfo.rson!=null">
                      <span style="color:#99a9bf">拒绝原因：</span>{{clientDetail.payinfo.rson}}
                    </div>
                  </el-alert>
                  <el-alert
                    v-if="clientDetail.paymark===0||clientDetail.paymark===1"
                    title="收款正在审核中，在此期间也可以重新编辑收款信息"
                    type="warning"
                    :closable="false"
                    style="margin-bottom: 20px"
                    show-icon>
                  </el-alert>
                  <el-form-item label="店面形式" prop="shopform">
                    <el-select v-model="payForm.shopform" style="width:100%" placeholder="请选择">
                      <el-option
                        v-for="item in dmxsList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="总面积" prop="totalarea">
                    <el-input v-model="payForm.totalarea" maxlength="20" placeholder="请输入店面总面积" show-word-limit></el-input>
                  </el-form-item>
                  <el-form-item label="品牌占用面积" prop="area">
                    <el-input v-model="payForm.area" maxlength="20" placeholder="请输入品牌占用面积" show-word-limit></el-input>
                  </el-form-item>
                  <el-form-item label="门店地址" prop="address">
                    <el-input v-model="payForm.address" maxlength="1000" placeholder="请输入门店地址" show-word-limit></el-input>
                  </el-form-item>
                  <el-form-item label="打款账户" prop="accountid">
                    <el-select v-model="payForm.accountid" style="width:100%" placeholder="请选择" clearable filterable>
                      <el-option-group
                        v-for="gitem in groupList"
                        v-if="gitem.nature===0"
                        :key="gitem.groupid"
                        :label="gitem.account_name">
                        <el-option
                          v-for="item in accountsList"
                          v-if="item.groupid===gitem.groupid"
                          :key="item.aid"
                          :label="item.name+'（'+item.card+'）'"
                          :value="item.aid">
                          <span style="float: left">{{ item.name }}</span>
                          <span style="float: right; color: #8492a6; font-size: 13px">{{ item.card }}</span>
                        </el-option>
                      </el-option-group>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="打款日期" prop="date">
                    <el-date-picker
                      v-model="payForm.date"
                      type="date"
                      style="width:240px"
                      format="yyyy年MM月dd日"
                      value-format="yyyy-MM-dd"
                      placeholder="选择日期">
                    </el-date-picker>
                  </el-form-item>
                  <el-form-item label="打款金额" prop="price">
                    <el-input v-model="payForm.price" oninput="value=value.replace(/[^0-9.]/g,'')" style="width: 200px"><template slot="append">元</template></el-input>
                  </el-form-item>
                  <el-form-item label="样品预存款" prop="joins">
                    <el-input v-model="payForm.joins" oninput="value=value.replace(/[^0-9.]/g,'')" style="width: 200px"><template slot="append">元</template></el-input>
                  </el-form-item>
                  <el-form-item label="加盟费" prop="insure">
                    <el-input v-model="payForm.insure" oninput="value=value.replace(/[^0-9.]/g,'')" style="width: 200px"><template slot="append">元</template></el-input>
                  </el-form-item>
                  <el-form-item label="卡号" prop="card">
                    <el-input v-model="payForm.card" maxlength="100" placeholder="请输入汇款人“卡号/尾号”，例如“张三/1234”" show-word-limit></el-input>
                  </el-form-item>
                  <el-form-item label="打款凭证" prop="imgids">
                    <MultiImg :limit="9" :size="'sm'" :old="oldPayImgs" :key="payImgKey" v-model="payForm.imgids" />
                  </el-form-item>
                  <el-form-item label="备注" prop="remark">
                    <el-input type="textarea" v-model="payForm.remark" maxlength="200" show-word-limit></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-button type="primary" :loading="editPayLoading" @click="subPayEdit('payForm')">立即提交</el-button>
                  </el-form-item>
                </el-form>
              </el-card>
              <el-card shadow="never" class="base-info" v-if="clientDetail.mark>=3">
                <div slot="header" class="tit">
                  <span>合同信息</span>
                </div>
                <div class="text" v-loading="contractLoading">
                  <div class="l">
                    <span style="float: left" class="label">签订日期:</span>
                    <span>{{contract.time}}</span>
                  </div>
                  <div class="l">
                    <span style="float: left" class="label">签订地点:</span>
                    <span>{{contract.address}}</span>
                  </div>
                  <div class="l">
                    <span style="float: left" class="label">签订人员:</span>
                    <span>{{contract.username}}</span>
                  </div>
                  <div class="l">
                    <span style="float: left" class="label">客户全称:</span>
                    <span>{{contract.all_name}}</span>
                  </div>
                  <div class="l">
                    <span style="float: left" class="label">展厅负责:</span>
                    <span>{{contract.group_name}}</span>
                  </div>
                  <div class="l">
                    <span style="float: left" class="label">签订合同:</span>
                    <span>{{ contract.contarct_name }}（{{contract.contarct_code}}）</span>
                  </div>
                  <div class="l">
                    <span style="float: left" class="label">代理品牌:</span>
                    <span><el-tag v-for="b in contract.brandList" v-if="b.is_select==1" size="mini" :disable-transitions="true" style="margin-right: 10px" effect="plain">{{b.brand_name}}</el-tag></span>
                  </div>
                  <div class="l">
                    <span style="float: left" class="label">合同备注:</span>
                    <span>{{contract.remark!==null&&contract.remark!==undefined&&contract.remark!==''?contract.remark:'N/A'}}</span>
                  </div>
                  <div class="l">
                    <span style="float: left" class="label">合同原件:</span>
                    <el-image v-for="iurl in contractImg"
                              style="width: 60px; height: 60px;margin-right: 10px;margin-bottom: 10px;border: 1px dashed #f5f7fa;"
                              :src="iurl"
                              :preview-src-list="contractImg">
                    </el-image>
                  </div>
                </div>
              </el-card>
              <el-card shadow="never" class="base-info" v-if="clientDetail.mark===9" style="margin-top: 20px">
                <div slot="header" class="tit">
                  <span>样品预存款确认单</span>
                </div>
                <div class="text">
                  <div class="l">
                    <span style="float: left" class="label">申请人员:</span>
                    <span>{{clientDetail.payinfo.username}}</span>
                  </div>
                  <div class="l">
                    <span style="float: left" class="label">申请时间:</span>
                    <span>{{clientDetail.payinfo.time}}</span>
                  </div>
                  <div class="l">
                    <span style="float: left" class="label">招商总监:</span>
                    <span>{{clientDetail.payinfo.dirname}}</span>
                  </div>
                  <div class="l">
                    <span style="float: left" class="label">审核时间:</span>
                    <span>{{clientDetail.payinfo.dirtime}}</span>
                  </div>
                  <div class="l">
                    <span style="float: left" class="label">审核人员:</span>
                    <span>{{clientDetail.payinfo.auditname}}</span>
                  </div>
                  <div class="l">
                    <span style="float: left" class="label">审核时间:</span>
                    <span>{{clientDetail.payinfo.audittime}}</span>
                  </div>
                  <div class="l">
                    <span style="float: left" class="label">店面形式:</span>
                    <span>{{clientDetail.payinfo.shopform===0?'商场内店':clientDetail.payinfo.shopform===1?'店中店':clientDetail.payinfo.shopform===2?'沿街店':'N/A'}}</span>
                  </div>
                  <div class="l">
                    <span style="float: left" class="label">总面积:</span>
                    <span>{{clientDetail.payinfo.totalarea}}</span>
                  </div>
                  <div class="l">
                    <span style="float: left" class="label">品牌占用面积:</span>
                    <span>{{clientDetail.payinfo.area}}</span>
                  </div>
                  <div class="l">
                    <span style="float: left" class="label">门店地址:</span>
                    <span>{{clientDetail.province}}{{clientDetail.city}}{{clientDetail.county}}{{clientDetail.payinfo.address}}</span>
                  </div>
                  <div class="l">
                    <span style="float: left" class="label">打款账户:</span>
                    <span>{{clientDetail.payinfo.accountname}}（{{clientDetail.payinfo.accountcard}}）</span>
                  </div>
                  <div class="l">
                    <span style="float: left" class="label">打款日期:</span>
                    <span>{{clientDetail.payinfo.receipttime}}</span>
                  </div>
                  <div class="l">
                    <span class="label">打款金额:</span>
                    <span>{{clientDetail.payinfo.money}}元</span>
                    <span class="label" style="margin-left: 20px">样品预存款:</span>
                    <span>{{ clientDetail.payinfo.join}}元</span>
                    <span class="label" style="margin-left: 20px">加盟费:</span>
                    <span>{{ clientDetail.payinfo.insure}}元</span>
                  </div>
                  <div class="l">
                    <span style="float: left" class="label">打款卡号:</span>
                    <span>{{ clientDetail.payinfo.card}}</span>
                  </div>
                  <div class="l">
                    <span style="float: left" class="label">打款备注:</span>
                    <span>{{clientDetail.payinfo.remark!==null&&clientDetail.payinfo.remark!==undefined&&clientDetail.payinfo.remark!==''?clientDetail.payinfo.remark:'N/A'}}</span>
                  </div>
                  <div class="l">
                    <span style="float: left" class="label">打款凭证:</span>
                    <el-image v-for="iurl in clientDetail.payinfo.payImgs"
                              style="width: 60px; height: 60px;margin-right: 10px;margin-bottom: 10px;border: 1px dashed #f5f7fa;"
                              :src="iurl"
                              :preview-src-list="clientDetail.payinfo.payImgs">
                    </el-image>
                  </div>
                  <div class="l" style="align-content: center" v-if="clientDetail.jmjtk===null||clientDetail.jmjtk===undefined||clientDetail.jmjtk===''">
                    <el-button  style="align-content: center" type="danger" size="small" @click="jmjRefundApply()">申请退款</el-button>
                  </div>
                </div>
              </el-card>
              <el-card shadow="never" style="margin-top: 20px" class="base-info" v-if="(clientDetail.jmjtk!==null&&clientDetail.mark===9)||clientDetail.mark===7">
                <div slot="header" class="tit">
                  <span>样品预存款退款</span>
                  <div style="position: absolute;right: 0;top: 0"  v-if="clientDetail.jmjtk.mark!==2">
                    <el-button  style="align-content: center" type="primary" icon="el-icon-edit" size="mini" @click="jmjRefundApply()">编辑信息</el-button>
                  </div>
                </div>
                <el-alert
                  v-if="clientDetail.jmjtk.mark>=0&&clientDetail.jmjtk.mark<=1"
                  title="样品预存款退款正在审核中，在此期间也可以重新编辑退款信息"
                  type="warning"
                  :closable="false"
                  style="margin-bottom: 20px"
                  show-icon>
                </el-alert>
                <el-alert
                  v-if="(clientDetail.jmjtk.mark===3||clientDetail.jmjtk.mark===4)&&clientDetail.jmjtk.type===1"
                  title="样品预存款退款审核拒绝"
                  :closable="false"
                  style="margin-bottom: 20px"
                  type="error">
                  <div style="color:#606266;font-size: 13px;margin-bottom: 5px">
                    <span><span style="color:#99a9bf">审核时间：</span>{{clientDetail.jmjtk.mark===3?clientDetail.jmjtk.dirtime:clientDetail.jmjtk.audittime}}</span>
                    <span style="margin-left: 30px;"><span style="color:#99a9bf">审核人：</span>{{clientDetail.jmjtk.mark===3?clientDetail.jmjtk.dirname:clientDetail.jmjtk.auditname}}</span>
                  </div>
                  <div style="color:#606266;font-size: 13px;" v-if="clientDetail.jmjtk.rson!=''&&clientDetail.jmjtk.rson!=null">
                    <span style="color:#99a9bf">拒绝原因：</span>{{clientDetail.jmjtk.rson}}
                  </div>
                </el-alert>
                <div class="text" v-loading="jmjxxLoading">
                  <div class="l">
                    <span style="float: left" class="label">收款人:</span>
                    <span>{{clientDetail.jmjtk.name}}</span>
                  </div>
                  <div class="l">
                    <span style="float: left" class="label">开户行:</span>
                    <span>{{clientDetail.jmjtk.bank}}</span>
                  </div>
                  <div class="l">
                    <span style="float: left" class="label">退款金额:</span>
                    <span>{{clientDetail.jmjtk.money}}</span>
                  </div>
                  <div class="l">
                    <span style="float: left" class="label">收款卡号:</span>
                    <span>{{clientDetail.jmjtk.card}}</span>
                  </div>
                  <div class="l">
                    <span style="float: left" class="label">退款原因:</span>
                    <span>{{clientDetail.jmjtk.refundrson!==null&&clientDetail.jmjtk.refundrson!==undefined&&clientDetail.jmjtk.refundrson!==''?clientDetail.jmjtk.refundrson:'N/A'}}</span>
                  </div>
                  <div class="l">
                    <span style="float: left" class="label">退款备注:</span>
                    <span>{{clientDetail.jmjtk.remark!==null&&clientDetail.jmjtk.remark!==undefined&&clientDetail.jmjtk.remark!==''?clientDetail.jmjtk.remark:'N/A'}}</span>
                  </div>
                </div>
              </el-card>
            </div>
            <div v-if="activeViewName === 'dlxx'">
              <el-row :gutter="12">
                <el-col :span="8" v-for="item in clientDetail.brandinfo">
                  <el-card shadow="hover" class="brand-info">
                    <div class="main-info">
                      <el-image
                        style="width: 100%; height: 60px"
                        :src="item.brandlogo"
                        fit="contain"></el-image>
                    </div>
                    <div class="more-info">
                      <div class="info-row">
                        <span class="title">{{item.brandname}}</span>
                      </div>
                      <div class="info-row info-content">
                        <p><span>区域经理：</span>{{item.areaname!==null&&item.areaname!==undefined&&item.areaname!==''?item.areaname:'未分配'}}</p>
                        <p><span>销售客服：</span>{{item.servicename!==null&&item.servicename!==undefined&&item.servicename!==''?item.servicename:'未分配'}}</p>
                        <p><span>报价专员：</span>{{item.offername!==null&&item.offername!==undefined&&item.offername!==''?item.offername:'未分配'}}</p>
                      </div>
                    </div>
                  </el-card>
                </el-col>
              </el-row>
            </div>
            <div v-if="activeViewName === 'jdxq'" class="project-info" v-loading="overviewLoading">
              <el-alert
                v-if="clientDetail.project===null||clientDetail.project===undefined||clientDetail.project===NaN"
                title="此经销商建店事项还未立项"
                type="warning"
                :closable="false"
                show-icon>
              </el-alert>
              <el-row v-if="clientDetail.project!==null&&clientDetail.project!==undefined&&clientDetail.project!==NaN">
                <el-col :span="14">
                  <div class="overview-box">
                    <div :class="overviewChange===0?'overview-item active':'overview-item'" @click="setOverviewChange(0)">
                      <span>总数</span>
                      <div class="num">{{overviewNum.zs}}</div>
                      <el-progress :percentage="100" color="#3DA8F5" :show-text="false"></el-progress>
                    </div>
                    <div :class="overviewChange===1?'overview-item active':'overview-item'" @click="setOverviewChange(1)">
                      <span>已完成</span>
                      <div class="num">{{overviewNum.ywc}}</div>
                      <el-progress :percentage="overviewNum.zs>0?overviewNum.ywc/overviewNum.zs*100:0" color="#9ED979" :show-text="false"></el-progress>
                    </div>
                    <div :class="overviewChange===2?'overview-item active':'overview-item'" @click="setOverviewChange(2)">
                      <span>未完成</span>
                      <div class="num">{{overviewNum.wwc}}</div>
                      <el-progress :percentage="overviewNum.zs>0?overviewNum.wwc/overviewNum.zs*100:0" color="#FF8479" :show-text="false"></el-progress>
                    </div>
                    <div :class="overviewChange===3?'overview-item active':'overview-item'" @click="setOverviewChange(3)">
                      <span>已逾期</span>
                      <div class="num">{{overviewNum.yyq}}</div>
                      <el-progress :percentage="overviewNum.zs>0?overviewNum.yyq/overviewNum.zs*100:0" color="#FF9F00" :show-text="false"></el-progress>
                    </div>
                    <div :class="overviewChange===4?'overview-item active':'overview-item'" @click="setOverviewChange(4)">
                      <span>待认领</span>
                      <div class="num">{{overviewNum.drl}}</div>
                      <el-progress :percentage="overviewNum.zs>0?overviewNum.drl/overviewNum.zs*100:0" color="#A1A4D9" :show-text="false"></el-progress>
                    </div>
                    <div :class="overviewChange===5?'overview-item active':'overview-item'" @click="setOverviewChange(5)">
                      <span>时间待定</span>
                      <div class="num">{{overviewNum.sjdd}}</div>
                      <el-progress :percentage="overviewNum.zs>0?overviewNum.sjdd/overviewNum.zs*100:0" color="#9ED979" :show-text="false"></el-progress>
                    </div>
                    <div :class="overviewChange===6?'overview-item active':'overview-item'" @click="setOverviewChange(6)">
                      <span>今日到期</span>
                      <div class="num">{{overviewNum.jrdq}}</div>
                      <el-progress :percentage="overviewNum.zs>0?overviewNum.jrdq/overviewNum.zs*100:0" color="#FFC774" :show-text="false"></el-progress>
                    </div>
                    <div :class="overviewChange===7?'overview-item active':'overview-item'" @click="setOverviewChange(7)">
                      <span>逾期完成</span>
                      <div class="num">{{overviewNum.yqwc}}</div>
                      <el-progress :percentage="overviewNum.zs>0?overviewNum.yqwc/overviewNum.zs*100:0" color="#FF8478" :show-text="false"></el-progress>
                    </div>
                  </div>
                </el-col>
                <el-col :span="10">
                  <div class="info-box">
                    <el-progress type="circle" class="percent" :width="70" :percentage="projectPercent"></el-progress>
                    <div class="name"><el-button @click="goProjectDetail" type="text" icon="el-icon-document" size="mini" style="font-size: 16px;padding: 0">{{clientDetail.project.name}}</el-button></div>
                    <div class="time">{{clientDetail.project.username}}于 {{dateToWz(clientDetail.project.time)}} 创建</div>
                  </div>
                  <div class="info">
                    <div class="tit"><i class="el-icon-document"></i><span>项目说明</span></div>
                    <div class="txt">{{clientDetail.project.explain!==null&&clientDetail.project.explain!==''&&clientDetail.project.explain!==undefined?clientDetail.project.explain:'未填写'}}</div>
                  </div>
                  <div class="info">
                    <div class="tit"><i class="el-icon-date"></i><span>项目周期</span></div>
                    <div class="txt">{{dateToWz(clientDetail.project.startdate)}} - {{dateToWz(clientDetail.project.enddate)}}</div>
                  </div>
                  <div class="info">
                    <div class="tit"><i class="el-icon-finished"></i><span>项目状态</span></div>
                    <div class="txt">
                      <el-tag v-if="clientDetail.project.mark===0" type="danger" :disable-transitions="true" size="mini">未开始</el-tag>
                      <el-tag v-if="clientDetail.project.mark===1" type="success" :disable-transitions="true" size="mini">进行中</el-tag>
                      <el-tag v-if="clientDetail.project.mark===2" type="warning" :disable-transitions="true" size="mini">已暂停</el-tag>
                      <el-tag v-if="clientDetail.project.mark===3" :disable-transitions="true" size="mini">已完成</el-tag>
                      <el-tag v-if="clientDetail.project.mark===4" type="info" :disable-transitions="true" size="mini">已取消</el-tag>
                    </div>
                  </div>
                </el-col>
                <el-col :span="24" style="padding-top: 20px">
                  <el-table
                    :data="overviewData"
                    border
                    style="width: 100%">
                    <el-table-column
                      type="index"
                      align="center"
                      width="50">
                    </el-table-column>
                    <el-table-column
                      label="计划周期"
                      width="220">
                      <template slot-scope="scope">
                        <span v-if="scope.row.startdate!==null&&scope.row.startdate!==undefined&&scope.row.startdate!==''&&scope.row.enddate!==null&&scope.row.enddate!==undefined&&scope.row.enddate!==''">{{dateToWz(scope.row.startdate)}}-{{dateToWz(scope.row.enddate)}}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="taskname"
                      label="事项"
                      width="140">
                    </el-table-column>
                    <el-table-column
                      prop="username"
                      label="执行人"
                      width="80">
                    </el-table-column>
                    <el-table-column
                      label="当前阶段"
                      width="120">
                      <template slot-scope="scope">
                        <span>{{scope.row.stagename}}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="当前进度"
                      width="100">
                      <template slot-scope="scope">
                        {{scope.row.psid===0?100:scope.row.percent}}%
                      </template>
                    </el-table-column>
<!--                    <el-table-column-->
<!--                      label="优先级"-->
<!--                      width="120">-->
<!--                      <template slot-scope="scope">-->
<!--                        <el-tag :type="scope.row.priority===1?'':scope.row.priority===2?'warning':scope.row.priority===3?'danger':'info'" size="small" effect="plain">{{scope.row.priority===1?'普通':scope.row.priority===2?'紧急':scope.row.priority===3?'非常紧急':'较低'}}</el-tag>-->
<!--                      </template>-->
<!--                    </el-table-column>-->
                    <el-table-column
                      prop="stagename"
                      label="实际工期"
                      min-width="220">
                      <template slot-scope="scope">
                        <span v-if="scope.row.startdateReal!==null&&scope.row.startdateReal!==undefined&&scope.row.startdateReal!==''&&scope.row.enddateReal!==null&&scope.row.enddateReal!==undefined&&scope.row.enddateReal!==''">{{dateToWz(scope.row.startdateReal)}}-{{dateToWz(scope.row.enddateReal)}}</span>
                      </template>
                    </el-table-column>
                  </el-table>
                </el-col>
              </el-row>
            </div>
          </el-col>
        </el-row>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="yxjtkVisible"
      title="意向金退款申请"
      width="500px"
      :destroy-on-close="true"
      :lock-scroll="true"
      custom-class="khgl-client-detail"
      :append-to-body="true">
      <div class="view-box" v-loading="yxjtkLoading">
        <el-form ref="yxjtkForm" :model="yxjtkForm" :rules="yxjtkRules" label-position="right" label-width="75px" size="small">
          <el-form-item label="收款人" prop="yxjtkname">
            <el-input v-model="yxjtkForm.yxjtkname" maxlength="20" placeholder="请输入收款人姓名" show-word-limit></el-input>
          </el-form-item>
          <el-form-item label="退款金额" prop="yxjtkmoney">
            <el-input v-model="yxjtkForm.yxjtkmoney" oninput="value=value.replace(/[^0-9.]/g,'')" style="width: 200px"><template slot="append">元</template></el-input>
          </el-form-item>
          <el-form-item label="收款卡号" prop="yxjtkcard">
            <el-input v-model="yxjtkForm.yxjtkcard" maxlength="100" placeholder="请输入收款人卡号" show-word-limit></el-input>
          </el-form-item>
          <el-form-item label="开户行" prop="yxjtkbank">
            <el-input v-model="yxjtkForm.yxjtkbank" maxlength="100" placeholder="请输入开户行" show-word-limit></el-input>
          </el-form-item>
          <el-form-item label="退款原因" prop="refundrson">
            <el-input type="textarea" v-model="yxjtkForm.refundrson"  show-word-limit></el-input>
          </el-form-item>
          <el-form-item label="备注" prop="xjtkremark">
            <el-input type="textarea" v-model="yxjtkForm.yxjtkremark"  maxlength="200" show-word-limit></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" :loading="yxjtkBtnLoading" @click="changeRefund('yxjtkForm')">提交</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="jmjtkVisible"
      title="样品预存款退款申请"
      width="500px"
      :destroy-on-close="true"
      :lock-scroll="true"
      custom-class="khgl-client-detail"
      :append-to-body="true">
      <div class="view-box" v-loading="jmjtkLoading">
        <el-form ref="jmjtkForm" :model="jmjtkForm" :rules="jmjtkRules" label-position="right" label-width="75px" size="small">
          <el-form-item label="收款人" prop="jmjtkname">
            <el-input v-model="jmjtkForm.jmjtkname" maxlength="20" placeholder="请输入收款人姓名" show-word-limit></el-input>
          </el-form-item>
          <el-form-item label="退款金额" prop="jmjtkmoney">
            <el-input v-model="jmjtkForm.jmjtkmoney" oninput="value=value.replace(/[^0-9.]/g,'')" style="width: 200px"><template slot="append">元</template></el-input>
          </el-form-item>
          <el-form-item label="收款卡号" prop="jmjtkcard">
            <el-input v-model="jmjtkForm.jmjtkcard" maxlength="100" placeholder="请输入汇款人“卡号/尾号”，例如“张三/1234”" show-word-limit></el-input>
          </el-form-item>
          <el-form-item label="开户行" prop="jmjtkbank">
            <el-input v-model="jmjtkForm.jmjtkbank" maxlength="100" placeholder="请输入开户行" show-word-limit></el-input>
          </el-form-item>
          <el-form-item label="退款原因" prop="refundrson">
            <el-input type="textarea" v-model="jmjtkForm.refundrson"  show-word-limit></el-input>
          </el-form-item>
          <el-form-item label="备注" prop="jmjtkremark">
            <el-input type="textarea" v-model="jmjtkForm.jmjtkremark"  maxlength="200" show-word-limit></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" :loading="jmjtkBtnLoading" @click="jmjtkChangeRefund('jmjtkForm')">提交</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import {
  addClient,
  getClientDetail,
  getClientList,
  delClient,
  forwardClient,
  getWays,
  getClentFollowList,
  editFollowRecord,
  changeClientIntent,
  intoHighSeas,
  getBrandList,
  getContractList,
  signContract,
  getSignedContract,
  addOrUpdateWaitPay,
  getClientWaitPayNum,
  getProjectTaskListByPid, addOrEditYxjClientRefund
} from '@/api/work'
import { formatDate, getAccounts, getGroupReport } from '@/api/pub'
import { validatePhoneNumber } from '@/utils/validate'
import { getCity } from '@/utils/city'
import MultiImg from '@/components/upload/MultiImg'
import elichain_photo from '@/assets/elichain_photo.jpg'
export default {
  name: 'khgl',
  computed: {
    user: getUser
  },
  components: {
    MultiImg
  },
  data() {
    const validateTel = (rule, value, callback) => {
      if (!validatePhoneNumber(value)) {
        callback(new Error('请输入正确的联系电话'))
      } else {
        callback()
      }
    }
    return {
      elichain_photo: elichain_photo,
      contractList: [],
      groupList: [],
      brandList: [],
      accountsList: [],
      dmxsList: [{ id: 0, name: '商场内店' }, { id: 1, name: '店中店' }, { id: 2, name: '沿街店' }],
      groupid: 1,
      activeName: 'first',
      activeViewName: 'gjjl',
      search: '',
      loading: false,
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      editInfoVisible: false,
      editloading: false,
      cityoptions: getCity(),
      editTitle: '',
      eForm: {
        cid: 0,
        name: '',
        tel: '',
        sex: 2,
        wchat: '',
        city: [],
        groupid: null,
        remark: '',
        shop: '',
        area: null,
        source: null,
        level: 1
      },
      eRules: {
        name: [{ required: true, message: '请输入客户姓名', trigger: 'blur' }],
        tel: [{ required: true, trigger: 'blur', validator: validateTel }],
        sex: [{ required: true, message: '请选择性别', trigger: 'change' }],
        city: [{ type: 'array', required: true, message: '请选择客户所在地区', trigger: 'blur' }],
        area: [{ pattern: /(^[1-9]\d*(\.\d{1,2})?$)|(^0(\.\d{1,2})?$)/, message: '请输入正确的面积', trigger: 'blur', required: false }],
        source: [{ required: true, message: '请选择客户来源', trigger: 'change' }]
      },
      viewVisible: false,
      viewLoading: false,
      clientDetail: {
        areadealerlst: [],
        project: {}
      },
      wayOption: [],
      areaKey: '',
      detailKey: '',
      forwardKey: '',
      followImgKey: '',
      htqdImgKey: '',
      wayKey: '',
      payImgKey: '',
      followFrom: {
        cfid: '0',
        way: '',
        content: '',
        imgids: []
      },
      editFollowLoading: false,
      followLoading: false,
      followList: [],
      editRecordVisible: false,
      recordForm: {
        key: '',
        cfid: '',
        way: '',
        content: '',
        imgids: [],
        oldImages: []
      },
      rulesRecord: {
        way: [{ required: true, message: '请选择跟进方式', trigger: 'change' }]
      },
      editFollowLoading2: false,
      changeIntentLoading: false,
      intoHighSeasLoading: false,
      htqdForm: {
        groupId: '',
        clientname: '',
        time: '',
        address: '',
        contractid: null,
        allname: '',
        brand: [],
        imgids: [],
        remark: '',
        allnameArea: '',
        allnameTxt: ''
      },
      htqdRules: {
        groupId: [{ required: true, message: '请选择展厅负责组织', trigger: 'change' }],
        clientname: [{ required: true, message: '请选择要签订的客户', trigger: 'change' }],
        time: [{ required: true, message: '请选择签订日期', trigger: 'change' }],
        address: [{ required: true, message: '请输入签订地点', trigger: 'blur' }],
        contractid: [{ required: true, message: '请选择签订合同', trigger: 'change' }],
        allname: [{ required: true, message: '请输入客户全称', trigger: 'blur' }],
        brand: [{ required: true, message: '请选择代理品牌，至少一个品牌', trigger: 'change' }],
        imgids: [{ required: true, message: '请上传合同原件图片', trigger: 'change' }]
      },
      htqdLoading: false,
      isnotReset: false,
      contractLoading: false,
      contract: {},
      contractImg: [],
      oldPayImgs: [],
      payForm: {
        accountid: '',
        date: '',
        price: null,
        card: '',
        imgids: [],
        remark: '',
        payid: 0,
        joins: null,
        insure: null,
        shopform: null,
        totalarea: null,
        area: null,
        address: null
      },
      payRules: {
        accountid: [{ required: true, message: '请选择打款账户', trigger: 'change' }],
        date: [{ required: true, message: '请选择打款日期', trigger: 'change' }],
        price: [{ required: true, message: '请输入打款金额', trigger: 'blur' }],
        joins: [{ required: true, message: '请输入样品预存款', trigger: 'blur' }],
        insure: [{ required: true, message: '请输入加盟费', trigger: 'blur' }],
        card: [{ required: true, message: '请输入汇款人卡号', trigger: 'blur' }],
        imgids: [{ required: true, message: '请上传打款凭证', trigger: 'change' }],
        shopform: [{ required: true, message: '请选择店面形式', trigger: 'change' }],
        totalarea: [{ required: true, message: '请输入总面积', trigger: 'blur' }],
        area: [{ required: true, message: '品牌占用面积', trigger: 'blur' }],
        address: [{ required: true, message: '请输入门店地址', trigger: 'blur' }]
      },
      editPayLoading: false,
      waitPayNum: 0,
      overviewLoading: false,
      overviewBaseData: [],
      overviewData: [],
      projectPercent: 0,
      overviewNum: {
        zs: 0,
        ywc: 0,
        wwc: 0,
        yyq: 0,
        drl: 0,
        sjdd: 0,
        jrdq: 0,
        yqwc: 0
      },
      overviewChange: 0,
      yxjcityoptions: [],
      zyxChangeLoading: false,
      yxjxxLoading: false,
      oldyxjeditimgList: [],
      yxjpayImgs: [],
      yxjpayImgKey: '',
      yxjForm: {
        yxjimgids: [],
        ciid: null,
        userid: null,
        cid: null,
        city: [],
        bid: null,
        enjoy: '',
        aid: null,
        receipttime: '',
        money: null,
        card: '',
        remark: '',
        mark: null
      },
      yxjRules: {
        city: [{ type: 'array', required: true, message: '请选择城市', trigger: 'blur' }],
        bid: [{ required: true, message: '请选择品牌', trigger: 'change' }],
        money: [{ required: false, message: '请输入金额', trigger: 'blur' }],
        card: [{ required: true, message: '请输入汇款卡号', trigger: 'blur' }],
        receipttime: [{ required: true, message: '请选择打款日期', trigger: 'change' }],
        aid: [{ required: true, message: '请选择收款账户', trigger: 'change' }],
        yxjimgids: [{ required: true, message: '请上传打款凭证', trigger: 'blur' }]
      },
      yxjtkVisible: false,
      yxjtkLoading: false,
      yxjtkxxLoading: false,
      yxjtkBtnLoading: false,
      yxjtkForm: {
        crid: null,
        cid: null,
        userid: null,
        yxjtkmoney: null,
        yxjtkcard: null,
        yxjtkname: '',
        yxjtkbank: '',
        refundrson: '',
        yxjtkremark: '',
        yxjtkmark: null
      },
      yxjtkRules: {
        yxjtkmoney: [{ required: true, message: '请输入退款金额', trigger: 'blur' }],
        yxjtkcard: [{ required: true, message: '请输入收款卡号', trigger: 'blur' }],
        yxjtkname: [{ required: true, message: '请输入收款人', trigger: 'blur' }],
        yxjtkbank: [{ required: true, message: '请输入开户行', trigger: 'blur' }],
        refundrson: [{ required: true, message: '请输入退款原因', trigger: 'blur' }]
      },
      jmjtkVisible: false,
      jmjtkLoading: false,
      jmjxxLoading: false,
      jmjtkBtnLoading: false,
      jmjtkForm: {
        crid: null,
        cid: null,
        userid: null,
        jmjtkmoney: null,
        jmjtkcard: null,
        jmjtkname: '',
        jmjtkbank: '',
        refundrson: '',
        jmjtkremark: '',
        jmjtkmark: null
      },
      jmjtkRules: {
        jmjtkmoney: [{ required: true, message: '请输入退款金额', trigger: 'blur' }],
        jmjtkcard: [{ required: true, message: '请输入退款卡号', trigger: 'blur' }],
        jmjtkname: [{ required: true, message: '请输入收款人姓名', trigger: 'blur' }],
        jmjtkbank: [{ required: true, message: '请输入开户行', trigger: 'blur' }],
        refundrson: [{ required: true, message: '请输入退款原因', trigger: 'blur' }]
      }
    }
  },
  created() {
    this.getData()
    this.getWayList()
    this.getGroup()
    this.getBrandList()
    this.getContractList()
    this.getAccount()
    let _cityoptions = getCity()
    for (let a of _cityoptions) {
      for (let b of a.children) {
        b.children = null
      }
    }
    this.yxjcityoptions = _cityoptions
  },
  methods: {
    jmjtkChangeRefund(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.jmjtkBtnLoading) {
            this.$confirm('您确定要申请退款吗, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.jmjtkBtnLoading = true
              const data = {
                crid: this.jmjtkForm.crid,
                cid: this.jmjtkForm.cid,
                type: 1,
                refundrson: this.jmjtkForm.refundrson,
                money: this.jmjtkForm.jmjtkmoney,
                card: this.jmjtkForm.jmjtkcard,
                name: this.jmjtkForm.jmjtkname,
                bank: this.jmjtkForm.jmjtkbank,
                remark: this.jmjtkForm.jmjtkremark,
                userid: this.jmjtkForm.userid
              }
              addOrEditYxjClientRefund(data).then(response => {
                this.$message({
                  message: response.msg,
                  type: 'success'
                })
                this.jmjtkBtnLoading = false
                this.jmjtkVisible = false
                this.openDetails({ cid: this.clientDetail.cid })
                this.getData()
              }).catch(() => {
                this.yxjtkBtnLoading = false
                this.yxjtkVisible = false
              })
            })
          } else {
            return false
          }
        }
      })
    },
    jmjRefundApply() {
      this.jmjtkVisible = true
    },
    changeRefund(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.yxjtkBtnLoading) {
            this.$confirm('您确定要申请退款吗, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.yxjtkBtnLoading = true
              const data = {
                crid: this.yxjtkForm.crid,
                cid: this.yxjtkForm.cid,
                type: 0,
                refundrson: this.yxjtkForm.refundrson,
                money: this.yxjtkForm.yxjtkmoney,
                card: this.yxjtkForm.yxjtkcard,
                name: this.yxjtkForm.yxjtkname,
                bank: this.yxjtkForm.yxjtkbank,
                remark: this.yxjtkForm.yxjtkremark,
                userid: this.yxjtkForm.userid
              }
              addOrEditYxjClientRefund(data).then(response => {
                this.$message({
                  message: response.msg,
                  type: 'success'
                })
                this.yxjtkBtnLoading = false
                this.yxjtkVisible = false
                this.openDetails({ cid: this.clientDetail.cid })
                this.getData()
              }).catch(() => {
                this.yxjtkBtnLoading = false
                this.yxjtkVisible = false
              })
            })
          } else {
            return false
          }
        }
      })
    },
    refundApply() {
      this.yxjtkVisible = true
    },
    goProjectDetail() {
      this.viewVisible = false
      this.$router.push({ path: '/work/project_detail/' + this.clientDetail.project.pid })
    },
    dateToWz(d) {
      if (d !== null && d !== undefined) {
        if (d.length > 10) {
          d = d.substring(0, 10)
        }
        const darr = d.split('-')
        return darr[0] + '年' + darr[1] + '月' + darr[2] + '日'
      } else {
        return ''
      }
    },
    setOverviewChange(n) {
      this.overviewChange = n
      this.filterOverviewData()
    },
    filterOverviewData() {
      let _overviewData = []
      const newDate = new Date()
      const today = `${newDate.getFullYear()}-${newDate.getMonth() < 9 ? `0${newDate.getMonth() + 1}` : newDate.getMonth() + 1}-${newDate.getDate() < 10 ? `0${newDate.getDate()}` : newDate.getDate()}`
      for (const t of this.overviewBaseData) {
        if (this.overviewChange === 0) {
          _overviewData.push(t)
        } else if (this.overviewChange === 1) {
          if (t.psid === 0) {
            _overviewData.push(t)
          }
        } else if (this.overviewChange === 2) {
          if (t.psid !== 0) {
            _overviewData.push(t)
          }
        } else if (this.overviewChange === 3) {
          if (t.psid !== 0) {
            if (t.enddate !== null && t.enddate !== undefined && t.enddate !== '') {
              if (t.enddate !== today) {
                const oDate1 = new Date(t.enddate)
                const oDate2 = new Date(today)
                if (oDate1.getTime() < oDate2.getTime()) {
                  _overviewData.push(t)
                }
              }
            }
          }
        } else if (this.overviewChange === 4) {
          if (t.userid === 0 || t.userid === null || t.userid === undefined) {
            _overviewData.push(t)
          }
        } else if (this.overviewChange === 5) {
          if (t.enddate === null || t.enddate === undefined || t.enddate === '') {
            _overviewData.push(t)
          }
        } else if (this.overviewChange === 6) {
          if (t.psid !== 0) {
            if (t.enddate !== null && t.enddate !== undefined && t.enddate !== '') {
              if (t.enddate === today) {
                _overviewData.push(t)
              }
            }
          }
        } else if (this.overviewChange === 7) {
          if (t.psid === 0) {
            if (t.enddate !== null && t.enddate !== undefined && t.enddate !== '' && t.enddateReal !== undefined && t.enddateReal !== null && t.enddateReal !== '') {
              if (t.enddate !== today) {
                const oDate1 = new Date(t.enddate)
                const oDate2 = new Date(t.enddateReal)
                if (oDate1.getTime() < oDate2.getTime()) {
                  _overviewData.push(t)
                }
              }
            }
          }
        }
      }
      this.overviewData = _overviewData
    },
    getProjectTask() {
      this.overviewLoading = true
      getProjectTaskListByPid({ pid: this.clientDetail.project.pid }).then(response => {
        this.overviewBaseData = response.data
        let _ywc = 0, _wwc = 0, _yyq = 0, _drl = 0, _sjdd = 0, _jrdq = 0, _yqwc = 0
        const newDate = new Date()
        const today = `${newDate.getFullYear()}-${newDate.getMonth() < 9 ? `0${newDate.getMonth() + 1}` : newDate.getMonth() + 1}-${newDate.getDate() < 10 ? `0${newDate.getDate()}` : newDate.getDate()}`
        let unp = 0.0
        let _projectPercent = 0.0
        if (response.data.length > 0) {
          unp = 100 / response.data.length
        }
        for (const t of response.data) {
          if (t.psid === 0) {
            _projectPercent = _projectPercent + unp
            _ywc++
            if (t.enddate !== null && t.enddate !== undefined && t.enddate !== '' && t.enddateReal !== undefined && t.enddateReal !== null && t.enddateReal !== '') {
              if (t.enddate !== today) {
                const oDate1 = new Date(t.enddate)
                const oDate2 = new Date(t.enddateReal)
                if (oDate1.getTime() < oDate2.getTime()) {
                  _yqwc++
                }
              }
            }
          } else {
            if (t.percent > 0) {
              _projectPercent = _projectPercent + (t.percent / 100 * unp)
            }
            _wwc++
            if (t.enddate !== null && t.enddate !== undefined && t.enddate !== '') {
              if (t.enddate === today) {
                _jrdq++
              } else {
                const oDate1 = new Date(t.enddate)
                const oDate2 = new Date(today)
                if (oDate1.getTime() < oDate2.getTime()) {
                  _yyq++
                }
              }
            }
          }
          if (t.userid === 0 || t.userid === null || t.userid === undefined) {
            _drl++
          }
          if (t.enddate === null || t.enddate === undefined || t.enddate === '') {
            _sjdd++
          }
        }
        this.projectPercent = Math.floor(_projectPercent)
        this.overviewNum = {
          zs: response.data.length,
          ywc: _ywc,
          wwc: _wwc,
          yyq: _yyq,
          drl: _drl,
          sjdd: _sjdd,
          jrdq: _jrdq,
          yqwc: _yqwc
        }
        this.filterOverviewData()
        this.overviewLoading = false
      })
    },
    getWaitPayNum() {
      getClientWaitPayNum({ userid: this.user.dUserid }).then(response => {
        this.waitPayNum = response.data
      }).catch(() => {})
    },
    subPayEdit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.editPayLoading) {
            this.editPayLoading = true
            const data = {
              userid: this.user.dUserid,
              payid: this.payForm.payid,
              signid: this.clientDetail.cid,
              date: this.payForm.date,
              price: this.payForm.price,
              accountid: this.payForm.accountid,
              card: this.payForm.card,
              imgStr: this.payForm.imgids.join(','),
              remark: this.payForm.remark,
              join: this.payForm.joins,
              insure: this.payForm.insure,
              shopform: this.payForm.shopform,
              totalarea: this.payForm.totalarea,
              area: this.payForm.area,
              address: this.payForm.address
            }
            addOrUpdateWaitPay(data).then(response => {
              this.$message({
                message: '打款凭证提交成功',
                type: 'success'
              })
              this.editPayLoading = false
              this.oldPayImgs = []
              this.isnotReset = true
              this.openDetails({ cid: this.clientDetail.cid })
              this.getData()
            }).catch(() => {
              this.editPayLoading = false
            })
          } else {
            return false
          }
        } else {
          return false
        }
      })
    },
    getContractDetail() {
      this.contract = {}
      this.contractImg = []
      this.contractLoading = true
      getSignedContract({ signid: this.clientDetail.cid }).then(response => {
        this.contract = response.data
        this.contractLoading = false
        let imgs = []
        for (let c of this.contract.imgList) {
          imgs.push(c.img_url)
        }
        this.contractImg = imgs
      }).catch(() => {
        this.contractLoading = false
      })
    },
    subHtqd(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.htqdLoading) {
            this.htqdLoading = true
            const data = {
              userid: this.user.dUserid,
              clientid: this.clientDetail.cid,
              time: this.htqdForm.time,
              address: this.htqdForm.address,
              contractid: this.htqdForm.contractid,
              allname: this.htqdForm.allname,
              brandStr: this.htqdForm.brand.join(','),
              imgStr: this.htqdForm.imgids.join(','),
              remark: this.htqdForm.remark,
              exGroup: this.htqdForm.groupId
            }
            signContract(data).then(response => {
              this.$message({
                message: '客户合同签订成功',
                type: 'success'
              })
              this.htqdLoading = false
              this.isnotReset = true
              this.openDetails({ cid: this.clientDetail.cid })
              this.getData()
            }).catch(() => {
              this.htqdLoading = false
            })
          } else {
            return false
          }
        } else {
          return false
        }
      })
    },
    setAllName() {
      if (this.htqdForm.allnameArea !== null && this.htqdForm.allnameArea !== '' && this.htqdForm.allnameArea !== undefined && this.htqdForm.allnameTxt !== null && this.htqdForm.allnameTxt !== '' && this.htqdForm.allnameTxt !== undefined && '' !== this.htqdForm.allnameTxt.trim() && '' !== this.htqdForm.allnameArea.trim()) {
        this.htqdForm.allname = this.htqdForm.allnameArea + '-' + this.htqdForm.allnameTxt
      } else {
        this.htqdForm.allname = ''
      }
    },
    intoHighSeas() {
      if (!this.intoHighSeasLoading) {
        this.$prompt('此操作将不再跟进此客户，请输入原因并确定以继续', '放入公海', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPattern: /\S/,
          inputErrorMessage: '原因不可为空'
        }).then(({ value }) => {
          this.intoHighSeasLoading = true
          intoHighSeas({ clientid: this.clientDetail.cid, userid: this.user.dUserid, remark: value }).then(response => {
            this.$message({
              type: 'success',
              message: '客户已放入公海'
            })
            this.intoHighSeasLoading = false
            this.viewVisible = false
            this.getData()
          }).catch(() => {
            this.intoHighSeasLoading = false
          })
        }).catch(() => {})
      }
    },
    changeIntent(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.zyxChangeLoading) {
            this.$confirm('提交 "' + this.clientDetail.name + '" 客户转意向申请，招商总监与财务审核通过后将此客户转为意向客户, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.zyxChangeLoading = true
              const data = {
                ciid: this.yxjForm.ciid,
                userid: this.yxjForm.userid,
                cid: this.yxjForm.cid,
                province: this.yxjForm.city[0],
                city: this.yxjForm.city[1],
                bid: this.yxjForm.bid,
                enjoy: this.yxjForm.enjoy,
                aid: this.yxjForm.aid,
                receipttime: this.yxjForm.receipttime,
                money: this.yxjForm.money,
                card: this.yxjForm.card,
                remark: this.yxjForm.remark,
                imgStr: this.yxjForm.yxjimgids.join(',')
              }
              changeClientIntent(data).then(response => {
                this.$message({
                  message: response.msg,
                  type: 'success'
                })
                this.zyxChangeLoading = false
                this.openDetails({ cid: this.clientDetail.cid })
                this.getData()
              }).catch(() => {
                this.zyxChangeLoading = false
              })
            }).catch(() => {})
          }
        }else {
          return false
        }
      })

    },
    subEditRecord(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.editFollowLoading2) {
            if (this.recordForm.content === null || this.recordForm.content === undefined || this.recordForm.content === '') {
              if (this.recordForm.imgids.length <= 0) {
                this.$message.error('请输入跟进内容')
                return
              }
            }
            this.editFollowLoading2 = true
            const data = {
              cfid: this.recordForm.cfid,
              way: this.recordForm.way,
              content: this.recordForm.content,
              imgids: this.recordForm.imgids.join(','),
              userid: this.user.dUserid,
              cid: this.clientDetail.cid
            }
            editFollowRecord(data).then(response => {
              this.editRecordVisible = false
              this.editFollowLoading2 = false
              this.$message({
                message: response.msg,
                type: 'success'
              })
              this.getFollowList()
            }).catch(() => {
              this.editFollowLoading2 = false
              return false
            })
          } else {
            return false
          }
        } else {
          return false
        }
      })
    },
    editFollow(f) {
      let _oldImages = []
      for (const item of f.imglst) {
        const image = {
          id: item.imgid,
          url: item.imgurl
        }
        _oldImages.push(image)
      }
      this.recordForm = {
        key: new Date().getTime(),
        cfid: f.cfid,
        way: f.way,
        content: f.content,
        imgids: [],
        oldImages: _oldImages
      }
      this.editRecordVisible = true
    },
    subFollowRecord() {
      if (!this.editFollowLoading) {
        if (this.followFrom.content === null || this.followFrom.content === undefined || this.followFrom.content === '') {
          if (this.followFrom.imgids.length <= 0) {
            this.$message.error('请输入跟进内容')
            return
          }
        }
        if (this.followFrom.way === null || this.followFrom.way === undefined || this.followFrom.way === '') {
          this.$message.error('请选择跟进方式')
          return
        }
        this.editFollowLoading = true
        const data = {
          cfid: this.followFrom.cfid,
          way: this.followFrom.way,
          content: this.followFrom.content,
          imgids: this.followFrom.imgids.join(','),
          userid: this.user.dUserid,
          cid: this.clientDetail.cid
        }
        editFollowRecord(data).then(response => {
          this.editFollowLoading = false
          this.followFrom = {
            cfid: '0',
            way: '',
            content: '',
            imgids: []
          }
          this.followImgKey = new Date().getTime()
          this.followList = []
          this.$message({
            message: response.msg,
            type: 'success'
          })
          this.getFollowList()
        }).catch(() => {
          this.editFollowLoading = false
        })
      }
    },
    getFollowList() {
      this.followLoading = true
      getClentFollowList({ cid: this.clientDetail.cid }).then(response => {
        this.followLoading = false
        let _followList = response.data
        for (let t of _followList) {
          let _imgurlarr = []
          t.time = formatDate(Date.parse(t.time))
          for (const i of t.imglst) {
            _imgurlarr.push(i.imgurl)
          }
          t.imgurlarr = _imgurlarr
        }
        this.followList = _followList
      }).catch(() => {
        this.followLoading = false
      })
    },
    openDetails(row) {
      this.areaKey = new Date().getTime()
      this.detailKey = new Date().getTime() + 1
      this.forwardKey = new Date().getTime() + 2
      this.followImgKey = new Date().getTime() + 3
      this.wayKey = new Date().getTime() + 4
      this.htqdImgKey = new Date().getTime() + 5
      this.payImgKey = new Date().getTime() + 6
      this.yxjpayImgKey = new Date().getTime() + 7
      this.followFrom = {
        cfid: '0',
        way: '',
        content: '',
        imgids: []
      }
      this.htqdForm = {
        groupId: '',
        clientname: '',
        time: '',
        address: '',
        contractid: null,
        allname: '',
        brand: [],
        imgids: [],
        remark: '',
        allnameArea: '',
        allnameTxt: ''
      }
      this.followList = []
      if (!this.isnotReset) {
        this.activeViewName = 'gjjl'
      } else {
        this.isnotReset = false
      }
      this.viewVisible = true
      this.viewLoading = true
      const data = {
        userid: this.user.dUserid,
        clientid: row.cid,
        groupid: this.user.dGroupid
      }
      getClientDetail(data).then(response => {
        this.clientDetail = response.data
        this.clientDetail.createtime = formatDate(Date.parse(this.clientDetail.createtime))
        if (this.clientDetail.mark === 9) {
          let _payImgs = []
          for (let img of this.clientDetail.payinfo.imglst) {
            _payImgs.push(img.imgurl)
          }
          this.clientDetail.payinfo.payImgs = _payImgs
        }
        if (this.clientDetail.paymark === 0 || this.clientDetail.paymark === 1 || this.clientDetail.paymark === 3 || this.clientDetail.paymark === 4) {
          this.payForm = {
            accountid: this.clientDetail.payinfo.aid,
            date: this.clientDetail.payinfo.receipttime,
            price: this.clientDetail.payinfo.money,
            card: this.clientDetail.payinfo.card,
            imgids: [],
            remark: this.clientDetail.payinfo.remark,
            payid: this.clientDetail.payinfo.cpayid,
            joins: this.clientDetail.payinfo.join,
            insure: this.clientDetail.payinfo.insure,
            shopform: this.clientDetail.payinfo.shopform,
            totalarea: this.clientDetail.payinfo.totalarea,
            area: this.clientDetail.payinfo.area,
            address: this.clientDetail.payinfo.address
          }
          let _oldPayImgs = []
          for (let img of this.clientDetail.payinfo.imglst) {
            _oldPayImgs.push({ id: img.imgid, url: img.imgurl })
          }
          this.oldPayImgs = _oldPayImgs
        } else {
          this.oldPayImgs = []
          this.payForm = {
            accountid: '',
            date: '',
            price: null,
            card: '',
            imgids: [],
            remark: '',
            payid: 0,
            joins: null,
            insure: null,
            shopform: null,
            totalarea: null,
            area: null,
            address: null
          }
        }
        this.viewLoading = false
        this.getFollowList()
        if (this.clientDetail.mark >= 3) {
          this.getContractDetail()
        }
        if (this.clientDetail.mark === 9) {
          if (this.clientDetail.project !== null && this.clientDetail.project !== undefined && this.clientDetail.project !== NaN) {
            this.getProjectTask()
          }
        }
        this.yxjxxLoading = true
        let _clientInmon = this.clientDetail.clientInmon
        if (_clientInmon !== null && _clientInmon !== undefined) {
          let _yxjoldpayImgs = []
          let _yxjpayImgs = []
          for (let img of _clientInmon.clientInmonImgList) {
            _yxjoldpayImgs.push({ id: img.imgid, url: img.imgurl })
            _yxjpayImgs.push(img.imgurl)
          }
          this.yxjpayImgs = _yxjpayImgs
          this.oldyxjeditimgList = _yxjoldpayImgs
          this.yxjForm.yxjimgids = []
          this.yxjForm.ciid = _clientInmon.ciid
          this.yxjForm.userid = _clientInmon.userid
          this.yxjForm.cid = _clientInmon.cid
          this.yxjForm.city[0] = _clientInmon.province
          this.yxjForm.city[1] = _clientInmon.city
          this.yxjForm.bid = _clientInmon.bid
          this.yxjForm.enjoy = _clientInmon.enjoy
          this.yxjForm.aid = _clientInmon.aid
          this.yxjForm.receipttime = _clientInmon.receipttime
          this.yxjForm.money = _clientInmon.money
          this.yxjForm.card = _clientInmon.card
          this.yxjForm.remark = _clientInmon.remark
          this.yxjForm.mark = _clientInmon.mark
        } else {
          this.yxjForm.yxjimgids = []
          this.yxjpayImgs = []
          this.oldyxjeditimgList = []
          this.yxjForm.userid = this.user.dUserid
          this.yxjForm.cid = row.cid
          this.yxjForm.mark = -1
          this.yxjForm.ciid = null
          this.yxjForm.city = []
          this.yxjForm.bid = null
          this.yxjForm.enjoy = ''
          this.yxjForm.aid = null
          this.yxjForm.receipttime = ''
          this.yxjForm.money = 0
          this.yxjForm.card = ''
          this.yxjForm.remark = ''
        }
        this.yxjxxLoading = false
        let _yxjtk = this.clientDetail.yxjtk
        if (_yxjtk !== null && _yxjtk !== undefined) {
          this.yxjtkForm.crid = _yxjtk.crid
          this.yxjtkForm.cid = _yxjtk.cid
          this.yxjtkForm.refundrson = _yxjtk.refundrson
          this.yxjtkForm.yxjtkmoney = _yxjtk.money
          this.yxjtkForm.yxjtkcard = _yxjtk.card
          this.yxjtkForm.yxjtkname = _yxjtk.name
          this.yxjtkForm.yxjtkbank = _yxjtk.bank
          this.yxjtkForm.yxjtkremark = _yxjtk.remark
          this.yxjtkForm.userid = _yxjtk.userid
          this.yxjtkForm.yxjtkmark = _yxjtk.mark
        } else {
          this.yxjtkForm.crid = null
          this.yxjtkForm.cid = row.cid
          this.yxjtkForm.refundrson = ''
          this.yxjtkForm.yxjtkmoney = null
          this.yxjtkForm.yxjtkcard = ''
          this.yxjtkForm.yxjtkname = ''
          this.yxjtkForm.yxjtkbank = ''
          this.yxjtkForm.yxjtkremark = ''
          this.yxjtkForm.userid = this.user.dUserid
          this.yxjtkForm.yxjtkmark = -1
        }
        this.jmjxxLoading = false
        let _jmjtk = this.clientDetail.jmjtk
        if (_jmjtk !== null && _jmjtk !== undefined) {
          this.jmjtkForm.crid = _jmjtk.crid
          this.jmjtkForm.cid = _jmjtk.cid
          this.jmjtkForm.refundrson = _jmjtk.refundrson
          this.jmjtkForm.jmjtkmoney = _jmjtk.money
          this.jmjtkForm.jmjtkcard = _jmjtk.card
          this.jmjtkForm.jmjtkname = _jmjtk.name
          this.jmjtkForm.jmjtkbank = _jmjtk.bank
          this.jmjtkForm.jmjtkremark = _jmjtk.remark
          this.jmjtkForm.userid = _jmjtk.userid
          this.jmjtkForm.jmjtkmark = _jmjtk.mark
        } else {
          this.jmjtkForm.crid = null
          this.jmjtkForm.cid = row.cid
          this.jmjtkForm.refundrson = ''
          this.jmjtkForm.jmjtkmoney = null
          this.jmjtkForm.jmjtkcard = ''
          this.jmjtkForm.jmjtkname = ''
          this.jmjtkForm.jmjtkbank = ''
          this.jmjtkForm.jmjtkremark = ''
          this.jmjtkForm.userid = this.user.dUserid
          this.jmjtkForm.jmjtkmark = -1
        }
      }).catch(() => {
        this.viewLoading = false
        this.yxjxxLoading = false
      })
    },
    forwardC(u) {
      this.$confirm('确认将客户"' + this.clientDetail.name + '"移交给 ' + u.dName + ' 吗?', '移交客户', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        forwardClient({
          cid: this.clientDetail.cid,
          operuserid: this.user.dUserid,
          userid: u.dUserid
        }).then(response => {
          this.$message({
            message: `客户已移交给${u.dName}`,
            type: 'success'
          })
          this.viewVisible = false
          this.getData()
        }).catch(() => {})
      }).catch(() => {})
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.editloading) {
            this.editloading = true
            const data = {
              userid: this.user.dUserid,
              realname: this.eForm.name,
              tel: this.eForm.tel,
              weixin: this.eForm.wchat,
              province: this.eForm.city[0],
              city: this.eForm.city[1],
              county: this.eForm.city[2],
              remark: this.eForm.remark,
              clientid: this.eForm.cid,
              sex: this.eForm.sex,
              shop: this.eForm.shop,
              area: this.eForm.area,
              source: this.eForm.source,
              level: this.eForm.level
            }
            addClient(data).then(response => {
              this.$message({
                message: this.eForm.cid != 0 ? '客户信息修改成功' : '客户录入成功',
                type: 'success'
              })
              this.editInfoVisible = false
              this.editloading = false
              if (this.eForm.cid != 0) {
                if (this.viewVisible) {
                  this.openDetails({ cid: this.eForm.cid })
                }
              } else {
                this.groupid = 1
                this.activeName = 'first'
              }
              this.getData()
            }).catch(() => {
              this.editloading = false
            })
          } else {
            return false
          }
        } else {
          return false
        }
      })
    },
    editInfo(row) {
      if (row !== null) {
        this.editTitle = '编辑客户信息'
        this.eForm = {
          cid: row.cid,
          name: row.name,
          tel: row.tel,
          sex: row.sex,
          wchat: row.wchat,
          city: [row.province, row.city, row.county],
          groupid: row.groupid,
          remark: row.remark,
          shop: row.shop,
          area: row.area > 0 ? row.area : null,
          source: row.source,
          level: row.level
        }
      } else {
        this.editTitle = '新增客户信息'
        this.eForm = {
          cid: 0,
          name: '',
          tel: '',
          sex: 2,
          wchat: '',
          city: [],
          groupid: null,
          remark: '',
          shop: '',
          area: null,
          source: null,
          level: 1
        }
      }
      this.editInfoVisible = true
    },
    handleClick(tab, event) {
      let _groupid = 1
      if (tab.index == 1) {
        _groupid = 2
      } else if (tab.index == 2) {
        _groupid = 4
      } else if (tab.index == 3) {
        _groupid = 3
      } else if (tab.index == 4) {
        _groupid = 5
      }
      if (_groupid === this.groupid) {
        return
      }
      this.groupid = _groupid
      this.currentPage = 1
      this.getData()
    },
    Search() {
      if (this.search != null && this.search.trim() !== '') {
        this.currentPage = 1
        this.getData()
      } else {
        this.search = ''
        this.getData()
      }
    },
    getData() {
      this.loading = true
      const data = {
        userid: this.user.dUserid,
        groupid: this.groupid,
        content: this.search,
        page: this.currentPage,
        limit: this.pageSize
      }
      getClientList(data).then(response => {
        this.loading = false
        let _tableData = response.data
        for (let t of _tableData) {
          t.followtime = formatDate(Date.parse(t.followtime))
        }
        this.tableData = _tableData
        this.total = response.total
        this.getWaitPayNum()
      }).catch(() => {
        this.loading = false
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    },
    delClient(row) {
      this.$confirm('删除 "' + row.name + '" 客户, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delClient({ cid: row.cid }).then(response => {
          this.$message({
            message: response.msg,
            type: 'success'
          })
          this.viewVisible = false
          this.getData()
        }).catch(() => {})
      }).catch(() => {})
    },
    getWayList() {
      getWays().then(response => {
        this.wayOption = response.data
      }).catch(() => {})
    },
    getGroup() {
      getGroupReport().then(response => {
        this.groupList = response.data
      })
    },
    getBrandList() {
      getBrandList().then(response => {
        const _brandList = []
        for (const b of response.data) {
          // 特殊用户处理
          if (this.user.dUserid == 180) {
            if (b.brand_id === 1 || b.brand_id === 3) {
              _brandList.push(b)
            }
          }
          // 各个公司查看的品牌不同
          else if (this.user.dGroupid === 1) {
            if (b.brand_id === 3) {
              _brandList.push(b)
            }
          } else if (this.user.dGroupid === 2) {
            if (b.brand_id === 1 || b.brand_id === 2) {
              _brandList.push(b)
            }
          } else if (this.user.dGroupid === 35) {
            if (b.brand_id === 4) {
              _brandList.push(b)
            }
          }
        }
        this.brandList = _brandList
      }).catch(() => {})
    },
    getContractList() {
      getContractList({ page: 1, limit: 999999999, groupid: this.user.dGroupid }).then(response => {
        this.contractList = response.data
      }).catch(() => {})
    },
    getAccount() {
      getAccounts().then(response => {
        this.accountsList = response.data
      }).catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
.khgl-container {
  .group-container{
    width: 100%;
    position: relative;
    padding: 20px;
    .group-item{
      position: relative;
      padding: 9px 15px;
      background: #FFF;
      border: 1px dashed #DCDFE6;
      border-radius: 4px;
      display: inline-block;
      color: #606266;
      font-size: 12px;
      font-weight: 500;
      margin:0 20px 20px 0;
      .group-del{
        padding: 2px!important;
        font-size: 10px!important;
        position: absolute;
        right: -10px;
        top: -6px;
      }
    }
  }
  .tcf-row{
    .card{
      .card-body{
        .card-title{
          .search-mode{
            width: 300px;
            position: absolute;
            right: 0;
            top: 4px;
            .search-input{
              background-color: #F2F6FC;
              border:0;
              height: 30px;
              line-height: 30px;
              border-radius: 4px;
              color: #606266;
              padding: 0 40px 0 15px;
              -webkit-appearance: none;
              font-size: 12px;
              width: 193px;
              -webkit-box-sizing: border-box;
              box-sizing: border-box;
              outline: 0;
              &::-webkit-input-placeholder {
                color: #C0C4CC;
              }
              &::-ms-input-placeholder {
                color: #C0C4CC;
              }
            }
            .search-btn{
              position: absolute;
              right: 107px;
              height: 30px;
              width: 40px;
              line-height: 30px;
              top: 0;
              border: 0;
              background: transparent;
              text-align: center;
              padding: 0;
            }
            .plus-btn{
              position: absolute;
              right: 0;
              top: 0;
              height: 30px;
              line-height: 30px;
              padding: 0 15px;
            }
          }
        }
        .card-content{
          .client-list{
            width: 100%;
            position: relative;
            &:after{
              content: ' ';
              display: table;
              clear: both;
            }
            .client-item{
              width: 307px;
              float: left;
              margin-bottom: 17px;
              margin-right: 17px;
              border-radius: 4px;
              border: 1px solid #ebeef5;
              background-color: #fff;
              overflow: hidden;
              color: #303133;
              position: relative;
              cursor: pointer;
              padding: 5px 15px;
              transition: .3s;
              &:hover{
                box-shadow: 0 2px 12px 0 rgba(0,0,0,0.1);
              }
              .name{
                padding: 10px 0;
                span{
                  font-size: 14px;
                  font-weight: 500;
                }
                .client-sex{
                  width: 18px!important;
                  height: 18px!important;
                  vertical-align: -4px!important;
                }
                .mark{
                  float: right;
                  .el-dropdown-link{
                    color: #828792;
                  }
                }
              }
              .info-box{
                width: 100%;
                position: relative;
                height: 36px;
                line-height: 36px;
                .label{
                  width: 85px;
                  color: #828792;
                  float: left;
                }
                .txt{
                  width: 190px;
                  float: left;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                }
              }
            }
          }
          .el-table::before{
            height: 0!important;
          }
          .el-pagination{
            margin-top: 20px;
          }
        }
      }
    }
  }
}
.view-box{
  width: 100%;
  position: relative;
  .base-info{
    width: 100%;
    position: relative;
    .tit{
      width: 100%;
      position: relative;
      span{
        font-weight: 500;
      }
    }
    .text{
      font-size: 13px;
      .l{
        margin-bottom: 15px;
        .label{
          color: #828792;
          margin-right: 14px;
        }
        .name{
          font-weight: 500;
          font-size: 14px;
        }
        .client-sex{
          width: 18px!important;
          height: 18px!important;
          vertical-align: -4px!important;
        }
        &:last-child{
          margin-bottom: 0;
        }
        &:after{
          content: ' ';
          display: table;
          clear: both;
        }
      }
    }
  }
  .principal{
    width: 100%;
    position: relative;
    margin-top: 20px;
    .tit{
      width: 100%;
      position: relative;
      span{
        font-weight: 500;
      }
    }
  }
  .follow-from{
    width: 100%;
    position: relative;
    border: 1px solid #EBEEF5;
    margin-bottom: 10px;
    border-radius: 4px;
    padding-bottom: 10px;
    .follow-img-box{
      width: 100%;
      position: relative;
      padding: 5px 15px;
    }
    .btn-box{
      border-bottom: 1px solid #EBEEF5;
      width: 100%;
      height: 40px;
      line-height: 40px;
      position: relative;
      padding: 0 15px;
    }
  }
  .follow-list{
    width: 100%;
    position: relative;
    .edit-btn{
      position: absolute;
      right: 15px;
      top: 15px;
      z-index: 1;
    }
    .follow-item{
      width: 100%;
      position: relative;
      border: 1px solid #EBEEF5;
      margin-bottom: 20px;
      border-radius: 4px;
      padding: 15px;
      .follow-userinfo{
        width: 100%;
        position: relative;
        padding-left: 60px;
        .photo{
          position: absolute;
          top: 0;
          left: 0;
        }
        .name{
          font-size: 14px;
          font-weight: 500;
          margin-bottom: 4px;
          padding-top: 4px;
          span{
            font-size: 12px;
            margin-left: 10px;
          }
        }
        .time{
          font-size: 12px;
          color:#999;
        }
      }
      .follow-content{
        padding-top: 15px;
        font-size: 13px;
      }
      .follow-imgs{
        width: 100%;
        position: relative;
        margin-top: 10px;
        .follow-img{
          width:60px;
          height: 60px;
          margin-right: 10px;
          border:1px dashed #f5f7fa;
        }
      }
    }
  }
  .brand-info{
    margin:6px 0;
    .main-info{
      border-bottom: 1px solid #eee;
      position: relative;
      text-align: center;
    }
    .more-info{
      margin-top: 8px;
      .info-row{
        font-size: 12px;
        line-height: 22px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 4;
        -webkit-box-orient: vertical;
        text-align: center;
        .title {
          font-size: 16px;
        }
        p {
          margin: 4px 0 !important;
          span{
            color:#99a9bf;
          }
        }
      }
    }
  }
}
.project-info{
  .info-box{
    width: 100%;
    position: relative;
    padding-left: 90px;
    padding-top: 10px;
    margin-bottom: 30px;
    .percent{
      position: absolute;
      left: 0;
      top: 0;
    }
    .name{
      font-size: 16px;
      color: #262626;
    }
    .time{
      font-size: 14px;
      margin-top: 10px;
      color: #8c8c8c;
    }
  }
  .info{
    width: 100%;
    position: relative;
    padding-left: 90px;
    font-size: 14px;
    margin-top: 14px;
    .tit{
      width: 120px;
      position: absolute;
      left: 0;
      top: 0;
      color: #8c8c8c;
      i{
        margin-right: 8px;
      }
    }
    .txt{
      width: 100%;
      position: relative;
      color: #262626;
    }
  }
  .overview-box{
    width: 100%;
    position: relative;
    display: flex;
    flex-wrap: wrap;
    .overview-item{
      border: 1px solid #ffffff;
      cursor: pointer;
      height: 110px;
      margin: 0px 16px 16px 0;
      padding: 12px;
      width: 124px;
      span{
        color: rgb(140, 140, 140);
        font-size: 12px;
        white-space: nowrap;
      }
      .num{
        color: #262626;
        margin: 4px 0;
        font-weight: bold;
        font-size: 32px;
      }
      .el-progress-bar {
        padding-right: 0;
      }
      &:hover{
        .num{
          color: #409EFF;
        }
      }
    }
    .active{
      border: 1px solid rgb(229, 229, 229);
      border-radius: 4px
    }
  }
}
</style>
